import { isIdentifier } from '@angular/compiler';
import {
    Component,
    OnInit,
    ViewChild,
    NgModule,
    ElementRef,
    NgZone,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DbAttendeesProvider } from "src/app/providers/database/db-attendees";
import { Attendee } from "src/app/models/attendees";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { EmailProvider } from "../../../../../providers/email/email.service";
import { OrderType } from "src/app/paths/orderType";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { RegexProvider } from "src/app/providers/regex/regex.service";
import { TranslateService } from "@ngx-translate/core";
import { eventCustomField } from "../../../../../models/eventCustomField";
// import { eventCustomFieldAnswerOption } from "../../../../../models/eventCustomFieldAnswerOption";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { FilterPipe } from "src/app/pipes/filter.pipe";
import { DbGroupsProvider } from "src/app/providers/database/db-groups";
import { DbEventsProvider } from "src/app/providers/database/db.events";
import { DragulaService } from "ng2-dragula";
import { DragulaOptions } from "dragula";
import { Event } from "../../../../../models/event";
import { GlobalService } from "src/app/providers/global/global.service";
import { Languages } from "src/app/models/languages";
import { MenuIcons, icons } from "src/app/models/menu-icons";
import { PathIcons } from "src/app/paths/path-icons";
import * as jspdf from "jspdf";
import { take } from "rxjs/operators";
import { NameModule } from 'src/app/models/name-module';
import { UUID } from "angular2-uuid";
import { DBCustomFieldsProvider } from 'src/app/providers/database/db-custom-fields.service';
import { TypeUser } from 'src/app/enums/typeUser';
import { AuthService } from 'src/app/providers/auth/auth.service';
import { FormatedEventLanguageService } from 'src/app/providers/formated-event-language/formated-event-language.service';
// declare let LZString: any;
// declare let JSONC: any;
// import * as JSONC from 'jsoncomp';

declare let $: any;
type AOA = Array<Array<any>>;

@Component({
    selector: "app-attendees",
    templateUrl: "./attendees.component.html",
    styleUrls: ["./attendees.component.scss"],
})
@NgModule({
    declarations: [FilterPipe],
})
export class AttendeesComponent implements OnInit {
    @ViewChild("successSwal") public successSwal: SwalComponent;
    @ViewChild("errorSwal") public errorSwal: SwalComponent;
    @ViewChild("notReconfiguredSwal") public notReconfiguredSwal: SwalComponent;
    @ViewChild("confirmResetAccount") public confirmResetAccount: SwalComponent;
    @ViewChild("successEmailSwal") public successEmailSwal: SwalComponent;
    @ViewChild("errorEmailSwal") public errorEmailSwal: SwalComponent;
    @ViewChild("successPasswordSwal") public successPasswordSwal: SwalComponent;
    @ViewChild("errorPasswordSwal") public errorPasswordSwal: SwalComponent;
    @ViewChild("notExport") public notExport: SwalComponent;
    @ViewChild("inputFile") public inputFile: ElementRef;

    dragulaOptions: DragulaOptions = {
        moves: () => true,
    };

    onReorderShow: boolean = false;
    public module = null;
    public nameModule = null;
    public p: number = 1;
    public deleteAttendeeId: string;
    deleteAttendeeIndex: number;
    public listAttendees: Array<Attendee> = [];
    public allListAttendees: Array<Attendee> = [];
    public loader: boolean = true;
    public eventId: string = null;
    public moduleId: string = null;
    public emailsAttendee: string = null;
    public emailTitle: string = null;
    public emailBody: string = null;
    public attendeeObjEmail: Attendee = null;
    public attendeeRemoveId;
    public selectedAllInput: boolean = false;
    term: string = "";
    typeOrder: string = null;
    public attendeeSelected = [];

    public allowedEditProfileVal;

    public totalAttendeeUpdated: number = 0;
    public totalAttendeeCreated: number = 0;
    public totalAttendeeFail: number = 0;
    public docChoice: string;


    //CUSTOM FIELDS
    // Custom Field - Globais.
    errorFormCustomCreate: boolean;
    errorFormCustomEdit: boolean;
    formCustom: FormGroup;
    formCustomEdit: FormGroup;
    hideElement: boolean = false; // habilita ou desabilita o campo de edicao do Custom field
    listCustomField: any[] = []; // array list custom field attendee.
    editCustomField: eventCustomField;
    showTypeCustom: boolean = false; // mostra ou oculta o campo para criação de opções de resposta
    showTypeCustomEdit: boolean = false; // mostra ou oculta o campo para criação de opções de resposta do edit
    cfAnsOpts = { [UUID.UUID()]: new NameModule('','','','','')}; // custom field answer options
    edCfAnsOpts = {};   // edited cf answer options

    // EXCEL PROPERTIES
    identifier: number = 0;
    name: number = 1;
    email: number = 2;
    emailRecovery: number = 3;
    title: number = 4;
    company: number = 5;
    description: number = 6;
    picture: number = 7;
    website: number = 8;
    facebook: number = 9;
    twitter: number = 10;
    linkedin: number = 11;
    instagram: number = 12;
    groups: number = 13;
    documents: number = 14;
    customField: number = 15;

    // EXCEL PROPOERTIES TRANSLATED
    translatedIdentifier: number = 0;
    translatedTitle: number = 1;
    translatedDescription: number = 2;
    customFieldTranslated: number = 3;

    data: any = null;
    dataImportPtBR: any = null;
    dataImportEnUS: any = null;
    dataImportEsES: any = null;
    dataImportFrFR: any = null;
    dataImportDeDE: any = null;
    exportAttendees: AOA = null;
    newAttendees: Array<Attendee>; // new Attendees.
    messageErrors: Array<String>; // array with error messages.
    nameFile: string = null; // excel input change name
    theError: boolean = false; // display error messages
    theErrorApi: boolean = false; // display error after send data to API
    theErrorApiDb: boolean = false; // display error after send data to API and have DB error
    successMsg: boolean = false; // display success message
    loaderImport: boolean = false; // loader after click button import
    importingPercentage: number = 0; // percentage of import
    someAttendeesExcelDownload: Array<Attendee> = []; // attendees with errors to download excel
    dataExportAttendees: AOA = null; // data export all attendees
    dataExportAttendees_PtBR: AOA = null;
    dataExportAttendees_EnUS: AOA = null;
    dataExportAttendees_EsES: AOA = null;
    dataExportAttendees_FrFR: AOA = null;
    dataExportAttendees_DeDE: AOA = null;
    attendeeErrorsApi: Array<Attendee> = [];
    editProfileVal: boolean = false;
    requiredEditProfileVal: boolean = false;
    loaderBtnCustomField: boolean = false;
    loaderEditCustomField: boolean = false;
    fieldOptions;
    moduleGroupId: string = null;
    listGroup = [];
    groupFilter: string = "all";
    invalidCustomFields: Array<any> = [];
    invalidGroups: Array<any> = [];
    invalidDocuments: Array<any> = [];
    theErrorGroup: boolean = false;
    theErrorDocument: boolean = false;
    invalidEmailInAttendee: Array<any> = [];
    theErrorEmailInAttendee: boolean = false;
    theErrorCustom: boolean = false;
    loaderDeleteCustom: boolean = false;
    uidCustomFieldDelete: string = null;
    indexCustomFieldDelete: number;

    allowChatSetting: boolean = false;
    allowChatUse: boolean = null;
    allowFilterCompany: boolean = null;
    allowFilterPost: boolean = null;
    allowFilterCustomFields: boolean = null;
    allowFilterCustomsFieldsArray: boolean[] = [false];
    showLetters: boolean = null;
    emailVisibilty: boolean = null;
    btnVisioVisibilty: boolean = null;
    showOnlyLoggedUsersVisibilty: boolean = null;
    // allowVisioSetting: boolean = false;
    // allowVisioUse: boolean = null;
    allowPublicEventOptions: boolean = false;
    defaultModulePublicAttendees: boolean = false;
    event: Event;

    loaderIndividualEmail: boolean = false;
    errorEmailTitle: boolean = false;
    errorEmailBody: boolean = false;
    attendeeResetPasswordEmails: any = null;
    attendeeResetPass: Attendee = null;

    first_access_language: string = null;

    // get the language of the user.
    public userLanguage: string;
    languages: Languages = null; //event languages
    activeCustomFieldLanguage: string = "PtBR";
    principalEventLang: string = "PtBR";

    //icons custom fields
    iconsImg: MenuIcons[] = icons;
    selectedIcon: string = PathIcons.icon_quiz;
    selectedIconFamily: string = "material-icons";
    selectedIconEdit: string = PathIcons.icon_quiz;
    selectedIconFamilyEdit: string = "material-icons";
    msgCustomFieldError: string;
    eventLanguage: string;

    disableFilterComVisibility = false; // prevent multi click on filterVisibility company
    disableFilterPostVisibility = false; // prevent multi click on filterVisibility post
    disableCustomFieldsFilterVisibility = false;
    disableCustomFieldsFilterArrayVisibility: boolean[] = [];
    disableLettreVisibility = false; // prevent multi click on lettersVisibility
    customNameArray: any = [];  // TODO

    companyFilterText: string = ''
    postFilterText: string = ''
    disabledCompanyFilterText: boolean = false
    disabledPostFilterText: boolean = false

    ldr = {
        btnSvCFChanges: false,
    };

    constructor(
        private route: ActivatedRoute,
        private dbAttendee: DbAttendeesProvider,
        private emailSvc: EmailProvider,
        private regex: RegexProvider,
        private translateService: TranslateService,
        private fb: FormBuilder,
        private global: GlobalService,
        private dbGroups: DbGroupsProvider,
        private dbEvent: DbEventsProvider,
        private dragula: DragulaService,
        private zone: NgZone,
        private SCustomFields: DBCustomFieldsProvider,
        private auth: AuthService,
        private FormaterdLanguage: FormatedEventLanguageService
    ) {
        this.eventId = this.route.parent.params["_value"]["uid"];
        this.moduleId = this.route.snapshot.params["moduleId"];
        dragula.createGroup("bag-custom", this.dragulaOptions);

        this.hideElement = false; // habilita ou desabilita o campo de edicao do Custom field

        // Custom field - Iniciando Formulário para edição e criação.
        this.formCustom = fb.group({
            // criando formCustom para pegar as informações do formulário custom field
            name: this.fb.group({
                PtBR: [
                    "",
                    Validators.compose([
                        Validators.required,
                        Validators.maxLength(80),
                    ]),
                ],
                EnUS: [
                    "",
                    Validators.compose([
                        Validators.required,
                        Validators.maxLength(80),
                    ]),
                ],
                EsES: [
                    "",
                    Validators.compose([
                        Validators.required,
                        Validators.maxLength(80),
                    ]),
                ],
                FrFR: [
                    "",
                    Validators.compose([
                        Validators.required,
                        Validators.maxLength(80),
                    ]),
                ],
                DeDE: [
                    "",
                    Validators.compose([
                        Validators.required,
                        Validators.maxLength(80),
                    ]),
                ],
            }),
            group_type: ["text"],
            group_exibicao: ["1"],
            group_edicao: ["2"],
        });

        this.formCustomEdit = fb.group({
            // criando formCustom para pegar as informações do formulário custom field
            name: this.fb.group({
                PtBR: [
                    "",
                    Validators.compose([
                        Validators.required,
                        Validators.maxLength(80),
                    ]),
                ],
                EnUS: [
                    "",
                    Validators.compose([
                        Validators.required,
                        Validators.maxLength(80),
                    ]),
                ],
                EsES: [
                    "",
                    Validators.compose([
                        Validators.required,
                        Validators.maxLength(80),
                    ]),
                ],
                FrFR: [
                    "",
                    Validators.compose([
                        Validators.required,
                        Validators.maxLength(80),
                    ]),
                ],
                DeDE: [
                    "",
                    Validators.compose([
                        Validators.required,
                        Validators.maxLength(80),
                    ]),
                ],
            }),
            type: [null],
            group_exibicao: [null],
            group_edicao: [null],
            uid: [null],
        });
    }


    ngOnInit() {
        // start dragula reorder bag
        this.dragula.dropModel("bag-custom").subscribe((value: any) => {
            this.onReorder(value);
        });

        // $(document).ready(function () {
        //   $("body").tooltip({ selector: '[data-toggle=tooltip]' });
        // });
        this.getAllowedEditProfile();
        this.getModule();
        this.getUserLanguage();
        this.loadFieldsOptions();
        // this.loadFieldOptionsCustom();
        this.getCustomFields();
        this.getEvent();
        this.dbGroups.searchModulesAndGroups(this.eventId, (result) => {
            $(document).on("click", " .dropdown-menu", function (e) {
                e.stopPropagation();
            });
            this.listGroup = [];
            this.listGroup = result["groups"];
            this.moduleGroupId = result["moduleId"];
        });

        this.dbEvent.getEvent(this.eventId, (event) => {
            this.eventLanguage = this.FormaterdLanguage.convertLang(event.language);
        });
    }

    ngDoCheck() {
        // verifica se houve mudança no parâmetro do idModule
        if (this.moduleId !== this.route.params["_value"]["moduleId"]) {
            this.zone.run(() => {
                this.listCustomField = [];
                this.moduleId = this.route.params["_value"]["moduleId"];

                this.getAllowedEditProfile();
                this.getModule();
                this.getUserLanguage();
                this.getCustomFields();
                this.loadFieldsOptions();
                // this.loadFieldOptionsCustom();
                this.dbGroups.searchModulesAndGroups(this.eventId, (result) => {
                    $(document).on("click", " .dropdown-menu", function (e) {
                        e.stopPropagation();
                    });
                    this.listGroup = [];
                    this.listGroup = result["groups"];
                    this.moduleGroupId = result["moduleId"];
                });
            });
        }
    }

    setIcon(item) {
        this.selectedIcon = item.icon;
        this.selectedIconFamily = item.family;
        $(".dropdown-menu").removeClass("show");
    }

    setIconEdit(item) {
        this.selectedIconEdit = item.icon;
        this.selectedIconFamilyEdit = item.family;
    }

    // get the language of the user.
    // get the language of the user.
    userLanguageFormat: string = "PtBR";
    getUserLanguage() {
        this.global.getLanguage((language) => {
            this.userLanguage = language;
            this.userLanguageFormat = this.convertLangFormat(language);
        });
    }

    ngOnDestroy() {
        // remove dragula reorder bag case exit component
        this.dragula.destroy("bag-custom");
    }

    getEvent() {
        this.dbEvent.getEvent(this.eventId, (event: Event) => {
            if (typeof event !== "undefined" && event !== null) {
                this.event = event;
                this.requiredEditProfileVal = event.required_edit_profile;
                this.allowChatSetting = event.allow_chat;
                this.allowChatUse = event.allow_chat;
                // this.allowVisioSetting = event.allow_visio;
                // this.allowVisioUse = event.allow_visio;
                this.allowPublicEventOptions = event.visibility;
                this.principalEventLang = this.convertLangFormat(
                    this.event.language
                );
                this.activeCustomFieldLanguage = this.convertLangFormat(
                    this.event.language
                );
                this.languages = event.languages;
                if (this.moduleId == event.default_attendee_module) {
                    this.defaultModulePublicAttendees = true;
                }
            }
        });
    }
    // update order of modules
    onReorder(order: any): void {
        this.onReorderShow = true;
        this.listCustomField = order.targetModel;
        for (let i = 0; i < this.listCustomField.length; ++i) {
            this.listCustomField[i].order = i;
            // let customId = this.listCustomField[i].uid;
        }
    }

    updateDocVisibility() {
        // Initialize the docVisibility field for the first time a document is added to the event
        // 'Profil' is the default choice

        if (!this.docChoice || this.docChoice === undefined || this.docChoice === '') {
            this.docChoice = 'Profil';
        }

        this.dbAttendee.updateModuleDocumentsVisibility(this.moduleId, { docVisibility: this.docChoice }, (status) => {
            if (!status) {
                console.error('failed to update docVisibility');
            }
        });
    }

    saveCustomFieldsChanges() {
        this.ldr.btnSvCFChanges = true;
        this.SCustomFields.updateCustomFieldsOrder(
            this.eventId,
            this.moduleId,
            this.listCustomField
        ).catch(error => console.error(error))
        .finally(() => { this.ldr.btnSvCFChanges = false; });
    }

    getModule() {
        this.dbAttendee.attendeeModule(this.moduleId, async (module) => {
            this.module = module;
            this.nameModule = module.name;
            this.typeOrder = module["orderUsers"];
            this.allowChatUse = module["allow_chat"];
            this.allowFilterCompany =
                module["allowFilterCompany"] !== undefined
                    ? module["allowFilterCompany"]
                    : false;
            this.allowFilterCustomFields =
                module["allowFilterCustomFields"] !== undefined
                    ? module["allowFilterCustomFields"]
                    : false;
            this.allowFilterPost =
                module["allowFilterPost"] !== undefined
                    ? module["allowFilterPost"]
                    : false;
            this.showLetters =
                module["showLetters"] !== undefined
                    ? module["showLetters"]
                    : true;
            this.emailVisibilty =
                module["emailVisibilty"] !== undefined
                    ? module["emailVisibilty"]
                    : false;
            this.btnVisioVisibilty =
                module["btnVisioVisibilty"] !== undefined
                    ? module["btnVisioVisibilty"]
                    : false;
            this.showOnlyLoggedUsersVisibilty =
                this.module["showOnlyLoggedUsers"] !== undefined
                    ? module["showOnlyLoggedUsers"]
                    : false;
            this.companyFilterText = this.module['companyFilterText'] ? this.module['companyFilterText'] : ''
            this.postFilterText = this.module['postFilterText'] ? this.module['postFilterText'] : '';

            this.docChoice = module['docVisibility'] ? this.module['docVisibility'] : 'Profil';

            if (!module.firstAccessCodeLanguage) {
                this.first_access_language = this.event.language;
                this.changeFirstAccessLanguage();
            } else {
                this.first_access_language = module.firstAccessCodeLanguage;
            }
            this.loadAttendees();
        });
    }

    loadAttendees() {
        this.loader = true;
        this.listAttendees = [];
        this.allListAttendees = [];
        this.dbAttendee.getAttendees(
            this.moduleId,
            this.typeOrder
        ).then(attendees => {
            attendees.forEach(att => {
                this.listAttendees.push(this.instantiateAttendee(att));
                this.allListAttendees.push(this.instantiateAttendee(att));
            })
            this.msgCustomFieldError = "";
        }).catch(err => {
            console.error(err);
            this.msgCustomFieldError = this.translateService.instant(
                "global.customField_create_error"
            );
        }).finally(() => { this.loader = false; })
    }

    filterAttendeeGroup() {
        if (this.groupFilter == "all") {
            this.listAttendees = this.allListAttendees;
        } else {
            this.listAttendees = [];
            for (let attendee of this.allListAttendees) {
                for (let group of attendee.$groups) {
                    if (group.uid == this.groupFilter) {
                        this.listAttendees.push(attendee);
                    }
                }
            }
        }
    }

    loadFieldsOptions() {
        this.dbAttendee.getAttendeesFieldOptions(this.moduleId, (fields) => {
            this.fieldOptions = fields;
        });
    }

    instantiateAttendee(data) {
        let name = data.name;
        let email = data.email;
        let attendee = new Attendee(name, email, 5, this.eventId);

        attendee.$uid = data.uid;
        attendee.$emailRecovery = data.emailRecovery;
        attendee.$queryName = data.queryName;
        attendee.$identifier = data.identifier;
        attendee.$description = data.description;
        attendee.$company = data.company;
        attendee.$title = data.title;
        attendee.$photoUrl = data.photoUrl;
        attendee.$website = data.website;
        attendee.$facebook = data.facebook;
        attendee.$instagram = data.instagram;
        attendee.$linkedin = data.linkedin;
        attendee.$twitter = data.twitter;
        attendee.$createdAt = data.createdAt;
        attendee.$firstAccess = data.firstAccess;
        let groups = [];
        for (const uid in data.groups) {
            groups.push(data.groups[uid]);
        }
        attendee.$groups = groups.sort((a, b) =>
            a.name < b.name ? -1 : a.name > b.name ? 1 : 0
        );
        return attendee;
    }

    getAttendeeForSendEmail(attendee: Attendee) {
        this.attendeeObjEmail = attendee;
        if (attendee["emailRecovery"] !== null) {
            this.emailsAttendee =
                attendee["name"] +
                " <" +
                attendee["email"] +
                "; " +
                attendee["emailRecovery"] +
                ">";
        } else {
            this.emailsAttendee =
                attendee["name"] + " <" + attendee["email"] + ">";
        }
    }

    sendEmailToAttendee() {
        let attendeeEmails = [];
        this.errorEmailBody = false;
        this.errorEmailTitle = false;

        if (this.attendeeObjEmail["emailRecovery"] !== null) {
            attendeeEmails = [
                this.attendeeObjEmail["email"],
                this.attendeeObjEmail["emailRecovery"],
            ];
        } else {
            attendeeEmails = [this.attendeeObjEmail["email"]];
        }

        let email = {
            title: this.emailTitle,
            body: this.emailBody,
            email: attendeeEmails,
        };

        if (this.emailTitle !== null) {
            if (this.emailBody !== null) {
                this.loaderIndividualEmail = true;
                this.emailSvc.sendEmailToUser(email, (data) => {
                    this.loaderIndividualEmail = false;
                    if (data["result"] == true) {
                        this.successEmailSwal.fire();
                        $("#sendEmailUser").modal("toggle");
                        this.emailTitle = null;
                        this.emailBody = null;
                        this.attendeeObjEmail = null;
                    } else {
                        this.errorEmailSwal.fire();
                    }
                });
            } else {
                // body required
                this.errorEmailBody = true;
            }
        } else {
            // title required
            this.errorEmailTitle = true;
        }
    }

    getUserResetPassword(attendee: Attendee) {
        this.attendeeResetPass = attendee;
        if (attendee["emailRecovery"] !== null) {
            this.attendeeResetPasswordEmails = [
                attendee["email"],
                attendee["emailRecovery"],
            ];
        } else {
            this.attendeeResetPasswordEmails = [attendee["email"]];
        }
    }

    resetUserPassword() {
        this.auth.recoveryPassword(this.attendeeResetPasswordEmails[0])
            .then(() => this.successEmailSwal.fire())
            .catch(err => {
                console.error(err);
                this.errorEmailSwal.fire();
            })
    }

    changeOrder() {
        this.dbAttendee.changeOrderItems(
            this.eventId,
            this.moduleId,
            this.typeOrder,
            (data) => {
                if (data == true) {
                    this.loadAttendees();
                }
            }
        );
    }

    updateFieldRequired(field, status) {
        this.dbAttendee.changeRequiredField(
            this.eventId,
            this.moduleId,
            field,
            status,
            this.fieldOptions
        );
    }

    updatUniqueEditField(field, status) {
        this.dbAttendee.changeUniqueEditField(
            this.eventId,
            this.moduleId,
            field,
            status,
            this.fieldOptions
        );
    }

    updateHideField(field, status) {
        this.dbAttendee.changeHideField(
            this.eventId,
            this.moduleId,
            field,
            status,
            this.fieldOptions
        );
    }

    /**
     * Updates the provided fields in the respective custom field firestore
     * document
     * @param customFieldId
     * @param data e.g. { "field1": "value", "field2": false }
     */
    updateCFField(
        customFieldId: string,
        data: Object
    ): void {
        this.SCustomFields.updateCustomField(
            this.eventId,
            this.moduleId,
            customFieldId,
            data
        ).catch(error => console.error(error));
    }

    orderAttendees() {
        let aux;
        switch (this.typeOrder) {
            case OrderType.A_Z:
                aux = this.listAttendees;
                this.listAttendees = [];
                this.listAttendees = aux.sort(function (a, b) {
                    if (a.$queryName < b.$queryName) {
                        return -1;
                    }
                    if (a.$queryName > b.$queryName) {
                        return 1;
                    }
                    return 0;
                });
                break;

            case OrderType.Z_A:
                aux = this.listAttendees;
                this.listAttendees = [];
                this.listAttendees = aux.sort(function (a, b) {
                    if (a.$queryName < b.$queryName) {
                        return 1;
                    }
                    if (a.$queryName > b.$queryName) {
                        return -1;
                    }
                    return 0;
                });
                break;

            case OrderType.recentFirst:
                aux = this.listAttendees;
                this.listAttendees = [];
                this.listAttendees = aux.sort(
                    (a, b) => b.$createdAt - a.$createdAt
                ); // For descending sort
                break;

            case OrderType.oldFirst:
                aux = this.listAttendees;
                this.listAttendees = [];
                this.listAttendees = aux.sort(
                    (a, b) => a.$createdAt - b.$createdAt
                ); // For ascending sort
                break;
        }
    }

    selectedAll() {
        if (this.selectedAllInput) {
            for (let i = 0; i < this.listAttendees.length; i++) {
                this.attendeeSelected[this.listAttendees[i]["uid"]] = true;
            }
        } else {
            for (let i = 0; i < this.listAttendees.length; i++) {
                this.attendeeSelected[this.listAttendees[i]["uid"]] = false;
            }
        }
    }

    // get individual attendee to be deleted
    getRemoveAttendee(attendeeId, index) {
        this.attendeeRemoveId = attendeeId;
    }

    // delete attendee from event
    removeAttendee() {
        this.loader = true;
        let listRemove = [this.attendeeRemoveId];

        this.dbAttendee.removeAttendees(
            this.eventId,
            this.moduleId,
            listRemove
        ).then(() => {
            this.attendeeRemoveId = null;
            this.loadAttendees();
            this.successSwal.fire();
        }).catch(err => {
            console.error(err);
            this.errorSwal.fire();
            this.loader = false;
        });
    }

    attendeeIndexById(attendeeId) {
        return this.listAttendees
            .map(function (e) {
                return e.$uid;
            })
            .indexOf(attendeeId);
    }

    removeSelected() {
        this.loader = true;
        let listRemove = [];

        for (let i = 0; i < this.listAttendees.length; i++) {
            if (this.attendeeSelected[this.listAttendees[i].$uid] == true) {
                listRemove.push(this.listAttendees[i].$uid);
            }
        }

        this.dbAttendee.removeAttendees(
            this.eventId,
            this.moduleId,
            listRemove
        ).then(() => {
            for (let i = 0; i < this.attendeeSelected.length; i++) {
                // remove all selected box
                this.attendeeSelected[this.listAttendees[i].$uid] = false;
            }
            this.selectedAllInput = false;
            this.loadAttendees();
            this.successSwal.fire();
        }).catch(err => {
            console.error(err);
            this.errorSwal.fire();
        })
        .finally(() => this.loader = false);
    }

    // ------------------------------------------------------------------------
    // TODOS OS MÉTODOS E ACESSO AO BANCO RELACIONADO AO CUSTOM FIELD ATTENDEE.
    // ------------------------------------------------------------------------

    getCustomFields() {
        return new Promise<void>((res, rej) => {
            this.SCustomFields.getCustomFields(this.eventId, this.moduleId)
                .then((customFields) => {
                    this.listCustomField = customFields;
                    res();
                }).catch((error) => rej(error))
        });
    }

    changeCustomExibition() {
        let exibicaoValue = this.formCustom.value.group_exibicao;
        let ctrlEdicao = this.formCustom.get("group_edicao");

        if (exibicaoValue == "3") {
            this.formCustom.controls["group_edicao"].setValue("3");
            ctrlEdicao.disable();
        } else {
            ctrlEdicao.enable();
        }
    }

    //mostra ou oculta o bloco de adicionar opções de resposta do custom field
    changeTypeCustom() {
        //pega o valor do campo relacionado ao tipo do campo
        let value = this.formCustom.controls.group_type.value;

        //caso o valor do campo seja 'texto' oculta o campo e caso seja 'select' exibe
        if (value == "text") {
            this.showTypeCustom = false;
        } else {
            this.showTypeCustom = true;
        }
    }

    //mostra ou oculta o bloco de adicionar opções de resposta do custom field
    changeTypeCustomEdit() {
        //pega o valor do campo relacionado ao tipo do campo
        let value = this.formCustomEdit.controls.type.value;

        //caso o valor do campo seja 'texto' oculta o campo e caso seja 'select' exibe
        if (value == "text") {
            this.showTypeCustomEdit = false;
        } else {
            this.showTypeCustomEdit = true;
            this.addNewOptionCustomEdit();
        }
    }

    changeGroupExibicao() {
        if (this.formCustomEdit.controls.group_exibicao.value == "3") {
            this.formCustomEdit.get("group_edicao").disable();
        } else {
            this.formCustomEdit.get("group_edicao").enable();
        }
    }

    addNewOptionCustom() {
        this.cfAnsOpts[UUID.UUID()] = new NameModule("", "", "", "", "");
    }

    addNewOptionCustomEdit(): void {
        const el = <HTMLInputElement>document.getElementById("cfInpAddAnswerOp");
        if (!el.value.trim()) {
            return;
        }
        const value =  new NameModule("", "", "", "", "");
        value[this.activeCustomFieldLanguage] = el.value;
        const optionName = this.customFieldInstantiateName(value);
        if (!optionName.status) {
            console.error("An error occurred in AttendeesComponent.customFieldInstantiateName(...)");
            return;
        }

        this.edCfAnsOpts[UUID.UUID()] = optionName.names;
        el.value = "";
    }

    getDeleteInputOption(index) {
        delete this.cfAnsOpts[index];
    }

    getDeleteInputOptionEdit(index) {
        delete this.edCfAnsOpts[index];
    }

    customFieldNameRequired: boolean = false;
    customFieldOptionNameRequired: boolean = false;
    customFieldCreateAllow: boolean = true;

    createCustomField() {
        this.customFieldNameRequired = false;
        this.customFieldOptionNameRequired = false;
        this.loaderBtnCustomField = true;
        this.errorFormCustomCreate = false;
        this.customFieldCreateAllow = true;

        const data = this.formCustom.getRawValue();
        const customName = this.customFieldInstantiateName(data.name);
        if (!customName.status) {
            this.customFieldNameRequired = true;
            this.loaderBtnCustomField = false;
            return;
        }

        const customField = new eventCustomField( // Criando o Objeto para enviar ao banco.
            customName.names,
            data.group_type,
            data.group_exibicao,
            data.group_edicao
        );
        customField.icon = this.selectedIcon;
        customField.iconFamily = this.selectedIconFamily;
        customField.order = this.listCustomField.length;

        if (customField.type == "s") {   // select one answer
            customField.answerOptions = {};
            for (const id in this.cfAnsOpts) {
                // verify if at least one possible answer has any character in it
                const answerName = this.validateAnswerValue(this.cfAnsOpts[id]);
                if (!answerName.status) {
                    this.customFieldCreateAllow = false;
                    this.customFieldOptionNameRequired = true;
                    this.loaderBtnCustomField = false;
                    continue;
                }
                customField.answerOptions[id] = Object.assign({}, answerName.answer);
            }
            if (Object.keys(customField.answerOptions).length == 0) {
                $("#warningSelectOption").modal("show");
                return;
            }
        }

        this.SCustomFields.createCustomField(
            this.eventId,
            this.moduleId,
            customField
        ).then((customFieldData) => {
            let checkExist = this.checkIndexExists(
                this.listCustomField,
                customFieldData.uid
            );
            if (checkExist == -1) {
                this.listCustomField.push(customFieldData);
                //exibe alerta de sucesso
                this.successSwal.fire();
            }
            // this.listCustomField.push(customFieldData)
            this.loaderBtnCustomField = false;
            //reseta o form
            this.formCustom.patchValue({
                name: {
                    PtBR: "",
                    EnUS: "",
                    EsES: "",
                    FrFR: "",
                    DeDE: "",
                },
                // group_type: 'text',
                // group_exibicao: '1',
                // group_edicao: '2'
            });

            // this.formCustom.get('group_edicao').enable();

            //reseta a lista de respostas
            this.cfAnsOpts = { [UUID.UUID()]: new NameModule('','','','','')};
            //oculta o bloco de respostas
            // this.showTypeCustom = false;
        }).catch((error) => {
            console.error(error);
            this.loaderBtnCustomField = false;
            this.errorSwal.fire();
        });
    }

    checkIndexExists(array, itemId) {
        return array
            .map(function (e) {
                return e.uid;
            })
            .indexOf(itemId);
    }

    customFieldInstantiateName(names) {
        let obj = {
            status: 1,
            names: null,
        };
        let principalLanguage = this.convertLangFormat(this.event.language);
        if (names[principalLanguage] == "") {
            obj.status = 0;
            // error, blank name - required name
        } else {
            for (let lang in names) {
                if (lang !== principalLanguage) {
                    if (names[lang] == "") {
                        names[lang] = names[principalLanguage];
                    }
                }
            }
            obj.status = 1;
            obj.names = names;
        }
        return obj;
    }

    /**
     * @returns an object with two parms, status (boolean) that gives the
     * result of the validation; and answer (NameModule) with all languages
     * with some value, i.e., if the field of a language is empty, it receives
     * the value of the event main language
     */
    validateAnswerValue(answer: NameModule) {
        const principalLanguage = this.convertLangFormat(this.event.language);

        if (answer[principalLanguage] == "") {
            return { status: false, answer: null };
        }

        for (let lang in answer) {
            if (
                answer[lang] !== principalLanguage &&
                answer[lang].trim() == ""
            ) {
                answer[lang] = answer[principalLanguage];
            }
        }
        return { status: true, answer: answer }
    }

    // ativa a visualização do campo de edição custom field
    getEditCustom(index: string) {
        this.editCustomField = this.listCustomField[index];
        this.selectedIconEdit = this.listCustomField[index].icon;
        this.selectedIconFamilyEdit = this.listCustomField[index].iconFamily;

        const aux = `.hidden${index}`;
        if ($(aux).is(":visible")) {
            $(aux).hide();
        } else {
            $(".hideAll").hide();
            $(aux).show();
        }

        const customField = this.listCustomField[index];
        this.formCustomEdit.patchValue({
            uid: customField.uid,
            name: {
                PtBR: customField.name["PtBR"],
                EnUS: customField.name["EnUS"],
                EsES: customField.name["EsES"],
                FrFR: customField.name["FrFR"],
                DeDE: customField.name["DeDE"],
            },
            type: customField.type,
            group_exibicao: customField.exibicao,
            group_edicao: customField.edicao,
        });

        if (customField.type == "s") {
            this.showTypeCustomEdit = true;
            this.edCfAnsOpts = Object.assign({}, customField.answerOptions)
        } else {
            this.showTypeCustomEdit = false;
        }

        if (customField.exibicao == "3") {
            this.formCustomEdit.get("group_edicao").disable();
        } else {
            this.formCustomEdit.get("group_edicao").enable();
        }
    }

    isEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    // Editar o custom field selecionado.
    customFieldNameRequiredEdit: boolean = false;
    editCustomFieldAttendee(
        data: any,
        cf: eventCustomField,
        index: number
    ) {
        this.loaderEditCustomField = true;
        this.customFieldNameRequiredEdit = false;

        let toBeUpdated = {};
        if (
            data.name[this.activeCustomFieldLanguage] !=
            cf.name[this.activeCustomFieldLanguage]
        ) {
            const customName = this.customFieldInstantiateName(data.name);
            if (!customName.status) {
                this.customFieldNameRequiredEdit = true;
                return;
            }
            toBeUpdated['name'] = customName.names;
        }
        if (data.group_exibicao != cf.exibicao) {
            toBeUpdated['exibicao'] = data.group_exibicao;
        }
        if (data.group_edicao != cf.edicao || data.group_edicao == undefined) {
            if (data.group_exibicao == '3') {
                // if data.group_exibicao was changed to '3', data.group_edicao
                // has value 'undefined'
                toBeUpdated['edicao'] = '3';
            } else {
                toBeUpdated['edicao'] = data.group_edicao;
            }
        }

        if (cf.type == 's') {
            const ansOpts = Object.keys(cf.answerOptions);
            const edAnsOpts = Object.keys(this.edCfAnsOpts);
            if (
                ansOpts.length != edAnsOpts.length ||
                ansOpts.some((opt, i) => opt != edAnsOpts[i])
            ) { // check if both arrays are equal
                toBeUpdated["answerOptions"] = {};
                for (const id in this.edCfAnsOpts) {
                    const answerName = this.validateAnswerValue(this.edCfAnsOpts[id]);
                    if (!answerName.status) {
                        continue;
                    }
                    toBeUpdated["answerOptions"][id] = Object.assign({}, answerName.answer)
                }
                if (Object.keys(toBeUpdated["answerOptions"]).length == 0) {
                    delete toBeUpdated["answerOptions"];
                }
            }
        }

        this.SCustomFields.updateCustomField(
            this.eventId,
            this.moduleId,
            cf.uid,
            toBeUpdated
        ).then(() => {
            for (const [key, value] of Object.entries(toBeUpdated)) {
                cf[key] = value;
            }

            this.listCustomField[index] = cf;
            $(".hideAll").hide();
            this.successSwal.fire();
        }).catch((error) => {
            console.error(error);
            this.errorSwal.fire();
        }).finally(() => {
            this.loaderEditCustomField = false;
        });
    }

    getDeleteCustomField(customField, index) {
        this.uidCustomFieldDelete = customField.uid;
        this.indexCustomFieldDelete = index;
    }

    async removeCustomFieldAttendee() {
        this.loaderDeleteCustom = true;
        this.SCustomFields.deleteCustomField(
            this.eventId,
            this.moduleId,
            this.uidCustomFieldDelete,
            TypeUser.ATTENDEE
        ).then(async () => {
            await this.getCustomFields();
            this.successSwal.fire();
            this.loaderDeleteCustom = false;
        }).catch((error) => {
            console.error(error);
            this.errorSwal.fire();
            this.loaderDeleteCustom = false;
        });
    }

    getAllowedEditProfile() {
        this.dbAttendee.getAllowedEditProfile(this.moduleId, (data) => {
            this.allowedEditProfileVal = data;
        });
    }

    changeAllowedEditProfile() {
        let newValue;

        if (this.allowedEditProfileVal) {
            newValue = false;
        } else {
            newValue = true;
        }

        this.dbAttendee.changeAllowedEditProfile(
            this.moduleId,
            this.eventId,
            newValue,
            (data) => {
                if (data == "success") {
                    this.allowedEditProfileVal = newValue;
                } else {
                    this.errorSwal.fire();
                }
            }
        );
    }

    filterCF4ReqFields(customFields: eventCustomField[]) {
        return customFields.filter(cf => cf.edicao != '3');
    }

    /******************************************************** EXCEL IMPORT **************************************************************/

    /* GET EXCEL AND CONVERT TO JSON DATA */
    sheetValidFormat: boolean = false;
    onFileChange(evt: any) {
        this.preCheckError = false;
        this.sheetValidFormat = false;
        /* wire up file reader */
        const target: DataTransfer = <DataTransfer>evt.target;
        this.nameFile = target.files[0].name; // passa o nome do arquivo para o input

        if (target.files.length !== 1) {
            throw new Error("Cannot use multiple files");
        }

        const reader: FileReader = new FileReader();
        reader.onload = (e: any) => {
            /* read workbook */
            const bstr: string = e.target.result;
            const wb: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });
            this.messageErrors = [];
            for (let i = 0; i < wb.SheetNames.length; i++) {
                let sheetAuxName: string = wb.SheetNames[i];
                let wsAux: XLSX.WorkSheet = wb.Sheets[sheetAuxName];
                let sheetAuxData = <AOA>(
                    XLSX.utils
                        .sheet_to_json(wsAux, { header: 1 })
                        .filter((o) => !Object.keys(o).every((k) => !o[k]))
                );
                if (sheetAuxName.includes("Principal - ")) {
                    this.sheetValidFormat = true;
                }
                if (sheetAuxName !== "Principal - " + this.event.language) {
                    this.preCheckImport(sheetAuxData, sheetAuxName);

                    if (sheetAuxName == "pt-BR") {
                        this.dataImportPtBR = sheetAuxData;
                    }
                    if (sheetAuxName == "en-US") {
                        this.dataImportEnUS = sheetAuxData;
                    }
                    if (sheetAuxName == "es-ES") {
                        this.dataImportEsES = sheetAuxData;
                    }
                    if (sheetAuxName == "fr-FR") {
                        this.dataImportFrFR = sheetAuxData;
                    }
                    if (sheetAuxName == "de-DE") {
                        this.dataImportDeDE = sheetAuxData;
                    }
                }
            }
            /* grab first sheet */
            const wsname: string = wb.SheetNames[0];
            const ws: XLSX.WorkSheet = wb.Sheets[wsname];

            let datas = <AOA>(
                XLSX.utils
                    .sheet_to_json(ws, { header: 1 })
                    .filter((o) => !Object.keys(o).every((k) => !o[k]))
            );
            if (datas.length < 1000) {
                /* save data */
                this.data = <AOA>(
                    XLSX.utils
                        .sheet_to_json(ws, { header: 1 })
                        .filter((o) => !Object.keys(o).every((k) => !o[k]))
                );
            } else {
                this.messageErrors.push(
                    this.translateService.instant(
                        "global.required_docs_length_inf_1000"
                    )
                );
                this.preCheckError = true;
                this.theError = true;
            }
        };
        reader.readAsBinaryString(target.files[0]);
    }

    preCheckError: boolean = false;
    preCheckImport(data, tabName) {
        if (data.length > 0) {
            let row = 1;
            for (const element of data) {
                if (this.ignoreRowEmpty(element)) {
                    if (typeof element[this.identifier] !== "undefined") {
                        // converte ids números para strings
                        if (typeof element[this.identifier] === "number") {
                            const aux: number = element[this.identifier];
                            element[this.identifier] = aux.toString();
                        }
                    } else {
                        const column = this.checkLetterCols(this.identifier);
                        this.messageErrors.push(
                            tabName +
                                " -> " +
                                column +
                                row +
                                ": " +
                                " " +
                                this.translateService.instant(
                                    "global.required_id"
                                )
                        );
                        this.preCheckError = true;
                    }
                    row++;
                }
            }
        }
    }

    invalidFormatSheetMsg: string | null = null;
    checkImport() {
        this.invalidFormatSheetMsg = null;
        this.loaderImport = true;
        this.theError = false;
        this.theErrorApi = false;
        this.theErrorApiDb = false;
        this.successMsg = false;
        this.newAttendees = [];
        this.messageErrors = [];
        this.attendeeErrorsApi = [];
        let validRows: number = 0;

        if (this.data !== null)
            this.data = this.transformIdentifiersIntoString(this.data);

        if (this.dataImportEnUS !== null)
            this.dataImportEnUS = this.transformIdentifiersIntoString(
                this.dataImportEnUS
            );

        if (this.dataImportPtBR !== null)
            this.dataImportPtBR = this.transformIdentifiersIntoString(
                this.dataImportPtBR
            );

        if (this.dataImportEsES !== null)
            this.dataImportEsES = this.transformIdentifiersIntoString(
                this.dataImportEsES
            );

        if (this.dataImportFrFR !== null)
            this.dataImportFrFR = this.transformIdentifiersIntoString(
                this.dataImportFrFR
            );

        if (this.dataImportDeDE !== null)
            this.dataImportDeDE = this.transformIdentifiersIntoString(
                this.dataImportDeDE
            );

        if (this.preCheckError) {
            this.loaderImport = false;
            this.theError = true;
            this.theErrorApi = false;
            this.successMsg = false;
            this.theErrorApiDb = false;
            this.invalidFormatSheetMsg = null;
            return;
        } else if (!this.data) {
            this.loaderImport = false;
                this.theError = true;
                this.messageErrors.push(
                    this.translateService.instant("global.no_file_selected")
                );
            return;
        } else if (!this.sheetValidFormat) {
            this.loaderImport = false;
            this.theError = false;
            this.theErrorApi = false;
            this.successMsg = false;
            this.theErrorApiDb = false;
            this.invalidFormatSheetMsg = this.translateService.instant(
                "global.invalid_spreadsheet"
            );
            return;
        }


        const fieldNames = this.data[0];
        // row 0 are the collunm names
        for (let row = 1; row < this.data.length; row++) {
            const element = this.data[row];
            if (this.ignoreRowEmpty(element)) { // IGNORE EMPTY ROWS
                validRows++;
                const newAttendees = new Attendee(null, "", 5, this.eventId);
                // VALIDATE IDENTIFIERS
                if (typeof element[this.identifier] !== "undefined") {
                    // converte ids números para strings
                    if (typeof element[this.identifier] === "number") {
                        const aux: number = element[this.identifier];
                        element[this.identifier] = aux.toString();
                    }
                    newAttendees.$identifier = element[this.identifier];
                    this.checkNumberRowIds(newAttendees.$identifier, row);
                } else {
                    const column = this.checkLetterCols(this.identifier);
                    this.messageErrors.push(
                        "Principal -> " + column + row + ": " + " " +
                        this.translateService.instant("global.required_id")
                    );
                }

                // VALIDATE E-MAILS
                if (
                    typeof element[this.email] !== "undefined" &&
                    element[this.email] !== ""
                ) {
                    if (this.regex.validateEmail(element[this.email])) {
                        newAttendees.$email =
                            this.regex.removeAccents(element[this.email]);
                        newAttendees.$email = newAttendees.$email.toLowerCase()
                        this.checkNumberRowEmail(newAttendees.$email, row);
                    } else {
                        const column = this.checkLetterCols(this.email);
                        this.messageErrors.push(
                            "Principal -> " + column + row + ":" + " " +
                            this.translateService.instant("global.invalid_email")
                        );
                    }
                } else {
                    const column = this.checkLetterCols(this.email);
                    this.messageErrors.push(
                        "Principal -> " + column + row + ":" + " " +
                        this.translateService.instant("global.required_email")
                    );
                }

                if (
                    typeof element[this.emailRecovery] !== "undefined" &&
                    element[this.emailRecovery] !== ""
                ) {
                    if (this.regex.validateEmail(element[this.emailRecovery])) {
                        newAttendees.$emailRecovery = this.regex
                            .removeAccents(element[this.emailRecovery]);
                        newAttendees.$emailRecovery =
                            newAttendees.$emailRecovery.toLowerCase();
                    } else {
                        const column = this.checkLetterCols(this.emailRecovery)
                        this.messageErrors.push(
                            "Principal -> " + column + row + ":" + " " +
                            this.translateService.instant("global.invalid_email")
                        );
                    }
                }

                // VALIDATE NAME
                if (typeof element[this.name] !== "undefined") {
                    let name = element[this.name].toString();
                    name.trim();
                    newAttendees.$name = name;
                    newAttendees.$queryName = name.toUpperCase();
                } else {
                    const column = this.checkLetterCols(this.name);
                    this.messageErrors.push(
                        "Principal -> " + column + row + ": " + " " +
                        this.translateService.instant("global.alert_name")
                    );
                }

                const indexPrincipalLanguage = this.compareIdentifierAttendee(
                        newAttendees["identifier"],
                        this.data
                    );
                if (indexPrincipalLanguage > -1)
                    this.checkCustomFieldImport(
                        this.data[0],
                        this.data[indexPrincipalLanguage],
                        this.principalEventLang,
                        this.customField
                    );

                const indexTranslatedPtBr = this.compareIdentifierAttendee(
                        newAttendees["identifier"],
                        this.dataImportPtBR
                    );
                if (
                    indexTranslatedPtBr > -1 &&
                    this.principalEventLang !== "PtBR"
                ) {
                    const fieldNamesPtBR = this.dataImportPtBR[0];
                    newAttendees.$title["PtBR"] = (
                        this.dataImportPtBR[indexTranslatedPtBr][this.translatedTitle] &&
                        this.dataImportPtBR[indexTranslatedPtBr][this.translatedTitle]
                    ) ? this.dataImportPtBR[indexTranslatedPtBr][this.translatedTitle] : "";

                    newAttendees.$description["PtBR"] = (
                        this.dataImportPtBR[indexTranslatedPtBr][this.translatedDescription] &&
                        this.dataImportPtBR[indexTranslatedPtBr][this.translatedDescription]
                    ) ? this.dataImportPtBR[indexTranslatedPtBr][this.translatedDescription] : "";

                    this.checkCustomFieldImport(
                        fieldNamesPtBR,
                        this.dataImportPtBR[indexTranslatedPtBr],
                        "PtBR",
                        this.customFieldTranslated
                    );
                }

                const indexTranslatedEnUs = this.compareIdentifierAttendee(
                        newAttendees["identifier"],
                        this.dataImportEnUS
                    );
                if (
                    indexTranslatedEnUs > -1 &&
                    this.principalEventLang !== "EnUS"
                ) {
                    const fieldNamesEnUS = this.dataImportEnUS[0];
                    newAttendees.$title["EnUS"] = (
                        this.dataImportEnUS[indexTranslatedEnUs][this.translatedTitle] &&
                        this.dataImportEnUS[indexTranslatedEnUs][this.translatedTitle]
                    ) ? this.dataImportEnUS[indexTranslatedEnUs][this.translatedTitle] : "";

                    newAttendees.$description["EnUS"] = (
                        this.dataImportEnUS[indexTranslatedEnUs][this.translatedDescription] &&
                            this.dataImportEnUS[indexTranslatedEnUs][this.translatedDescription]
                    ) ? this.dataImportEnUS[indexTranslatedEnUs][this.translatedDescription]
                        .replace(/href="/g, 'class="wysiwyg-link" href="') :
                        "";

                    this.checkCustomFieldImport(
                        fieldNamesEnUS,
                        this.dataImportEnUS[indexTranslatedEnUs],
                        "EnUS",
                        this.customFieldTranslated
                    );
                }

                const indexTranslatedEsEs = this.compareIdentifierAttendee(
                        newAttendees["identifier"],
                        this.dataImportEsES
                    );
                if (
                    indexTranslatedEsEs > -1 &&
                    this.principalEventLang !== "EsES"
                ) {
                    const fieldNamesEsES = this.dataImportEsES[0];
                    newAttendees.$title["EsES"] = (
                        this.dataImportEsES[indexTranslatedEsEs][this.translatedTitle] &&
                        this.dataImportEsES[indexTranslatedEsEs][this.translatedTitle]
                    ) ? this.dataImportEsES[indexTranslatedEsEs][this.translatedTitle] : "";

                    newAttendees.$description["EsES"] = (
                        this.dataImportEsES[indexTranslatedEsEs][this.translatedDescription] &&
                        this.dataImportEsES[indexTranslatedEsEs][this.translatedDescription]
                    ) ? this.dataImportEsES[indexTranslatedEsEs][this.translatedDescription]
                        .replace(/href="/g, 'class="wysiwyg-link" href="') :
                        "";

                    this.checkCustomFieldImport(
                        fieldNamesEsES,
                        this.dataImportEsES[indexTranslatedEsEs],
                        "EsES",
                        this.customFieldTranslated
                    );
                }

                const indexTranslatedFrFr = this.compareIdentifierAttendee(
                        newAttendees["identifier"],
                        this.dataImportFrFR
                    );
                if (
                    indexTranslatedFrFr > -1 &&
                    this.principalEventLang !== "FrFR"
                ) {
                    const fieldNamesFrFR = this.dataImportFrFR[0];
                    newAttendees.$title["FrFR"] = (
                        this.dataImportFrFR[indexTranslatedFrFr][this.translatedTitle] &&
                        this.dataImportFrFR[indexTranslatedFrFr][this.translatedTitle]
                    ) ? this.dataImportFrFR[indexTranslatedFrFr][this.translatedTitle] : "";

                    newAttendees.$description["FrFR"] = (
                        this.dataImportFrFR[indexTranslatedFrFr][this.translatedDescription]  &&
                        this.dataImportFrFR[indexTranslatedFrFr][this.translatedDescription]
                    ) ? this.dataImportFrFR[indexTranslatedFrFr][this.translatedDescription]
                        .replace(/href="/g, 'class="wysiwyg-link" href="') :
                        "";
                    this.checkCustomFieldImport(
                        fieldNamesFrFR,
                        this.dataImportFrFR[indexTranslatedFrFr],
                        "FrFR",
                        this.customFieldTranslated
                    );
                }

                // DeDE
                const indexTranslatedDeDe = this.compareIdentifierAttendee(
                        newAttendees["identifier"],
                        this.dataImportDeDE
                    );
                if (
                    indexTranslatedDeDe > -1 &&
                    this.principalEventLang !== "DeDE"
                ) {
                    const fieldNamesDeDE = this.dataImportDeDE[0];
                    newAttendees.$title["DeDE"] = (
                        this.dataImportDeDE[indexTranslatedDeDe][this.translatedTitle] &&
                        this.dataImportDeDE[indexTranslatedDeDe][this.translatedTitle]
                    ) ? this.dataImportDeDE[indexTranslatedDeDe][this.translatedTitle] : "";

                    newAttendees.$description["DeDE"] = (
                        this.dataImportDeDE[indexTranslatedDeDe][this.translatedDescription] &&
                        this.dataImportDeDE[indexTranslatedDeDe][this.translatedDescription]
                    ) ? this.dataImportDeDE[indexTranslatedDeDe][this.translatedDescription]
                        .replace(/href="/g, 'class="wysiwyg-link" href="') :
                        "";

                    this.checkCustomFieldImport(
                        fieldNamesDeDE,
                        this.dataImportDeDE[indexTranslatedDeDe],
                        "DeDE",
                        this.customFieldTranslated
                    );
                }

                if (typeof element[this.title] !== "undefined")
                    newAttendees.$title[this.principalEventLang] =
                        element[this.title];

                if (element[this.description])
                    newAttendees.$description[this.principalEventLang] =
                        element[this.description].toString().replace(
                            /href="/g,
                            'class="wysiwyg-link" href="'
                        );

                if (element[this.picture])
                    newAttendees.$photoUrl = element[this.picture];

                if (element[this.company])
                    newAttendees.$company = element[this.company];

                if (element[this.website])
                    newAttendees.$website = element[this.website];

                if (element[this.facebook])
                    newAttendees.$facebook = element[this.facebook];

                if (element[this.twitter])
                    newAttendees.$twitter = element[this.twitter];

                if (element[this.linkedin])
                    newAttendees.$linkedin = element[this.linkedin];

                if (element[this.instagram])
                    newAttendees.$instagram = element[this.instagram];

                if (element[this.groups])
                    newAttendees.$groups = element[this.groups];

                if (element[this.documents])
                    newAttendees.$documents = element[this.documents];

                newAttendees.$language = this.event["language"];
                newAttendees.$customFields = this.allCustoms;
                this.newAttendees.push(newAttendees);
                this.allCustoms = [];

                if (this.messageErrors.length > 0) {
                    this.loaderImport = false;
                    this.theError = true;
                    this.theErrorApi = false;
                    this.successMsg = false;
                    this.theErrorApiDb = false;
                    this.invalidFormatSheetMsg = null;
                    this.sheetValidFormat = false;
                }
                this.clearInputFile(); // limpa o input do arquivo.
            }
        }

        // this.loaderImport = false //apagar
        if (this.newAttendees.length == validRows && !this.theError)
            this.importAttendees();
    }

    fixCustomFieldSelectOptions(attendees: any[]) {
        for (let attendee of attendees) {
            for (let customField of attendee.customFields) {
                if (customField.type === 's' || customField.type === 'select') {
                    const answerOptions = this.listCustomField.find(cf => cf.uid === customField.uid)?.answerOptions || {};
                    if (customField.value) {
                        const foundOptionId = Object.keys(answerOptions).find(id => {
                            const option = answerOptions[id];
                            return Object.values(option).includes(customField.value);
                        })
                        customField.answer = foundOptionId || null;
                    }
                }
            }
        }
    }

    importAttendees() {
        this.fixCustomFieldSelectOptions(this.newAttendees);

        this.dbAttendee.importAttendeesPerBatch(
            this.eventId,
            this.moduleId,
            this.nameModule,
            this.newAttendees,
            this.moduleGroupId,
            (progress) => {this.importingPercentage = Math.floor(progress * 100)},
        ).then((res) => {
            this.theError = false;
            this.theErrorApi = (res["emailDouble"].length > 0 || res["idDouble"].length > 0);
            this.theErrorApiDb = false;
            this.successMsg = (res["emailDouble"].length === 0 && res["idDouble"].length === 0);
            this.messageErrors = [];

            this.totalAttendeeCreated = res["success"].length;
            this.totalAttendeeUpdated = res["updateds"].length;
            this.totalAttendeeFail = res["fail"].length;

            if (res["failGroups"].length >= 1) {
                this.invalidGroups = res["failGroups"];
                this.theErrorGroup = true;
            }

            if (res["failDocuments"].length >= 1) {
                this.invalidDocuments = res["failDocuments"];
                this.theErrorDocument = true;
            }

            if (res["failCustomField"].length >= 1) {
                this.invalidCustomFields = res["failCustomField"];
                this.theErrorCustom = true;
            }

            // this.theError = (res["emailInAttendee"]?.length >= 1);
            // this.theErrorEmailInAttendee = (res["emailInAttendee"].length >= 1);
            // for (let attendee of res["emailInAttendee"]) {
            //     this.attendeeErrorsApi.push(attendee);
            //     this.messageErrors.push(
            //         attendee["email"] +
            //             " - " +
            //             this.translateService.instant(
            //                 "global.import_attendee_error_email_attendee"
            //             )
            //     );
            // }

            // attendees with double e-mail in event
            for (let attendee of res["emailDouble"]) {
                this.attendeeErrorsApi.push(attendee);
                if (attendee.type <= 3) {
                    this.messageErrors.push(
                        attendee["email"] +
                            " - " +
                            this.translateService.instant(
                                "global.email_invalid_attendee"
                            )
                    );
                } else {
                    this.messageErrors.push(
                        attendee["email"] +
                            " - " +
                            this.translateService.instant(
                                "global.email_double"
                            )
                    );
                }
            }

            this.theErrorApi = (res["fail"].length >= 1);
            for (let attendeeFail of res["fail"]) {
                this.attendeeErrorsApi.push(attendeeFail);
                this.messageErrors.push(
                    attendeeFail["email"] +
                        " - " +
                        this.translateService.instant(
                            "comp.attendees.attendee_failed_msg"
                        )
                );
            }

            // attendees with double identifier in event
            for (let attendee of res["idDouble"]) {
                this.attendeeErrorsApi.push(attendee);
                this.messageErrors.push(
                    attendee["identifier"] +
                        " - " +
                        this.translateService.instant(
                            "global.identifier_double"
                        )
                );
            }
        })
        .catch((err) => console.error(err))
        .finally(() => {
            this.loadAttendees();
            this.loaderImport = false;
            this.importingPercentage = 0;
        })
    }

    /**
     * transforms the data type of the identifiers column.
     * @param {*} spreadsheet
     * @returns any
     */

    transformIdentifiersIntoString(spreadsheet: any): any {
        for (const row of spreadsheet) {
            if (
                typeof row[this.translatedIdentifier] !== "undefined" &&
                row[this.translatedIdentifier] !== null
            )
                row[this.translatedIdentifier] =
                    row[this.translatedIdentifier].toString();
        }

        return spreadsheet;
    }

    /**
     * fetch the index of the spreadsheet (excel) corresponding to the identifier.
     * @param {any} spreadsheet
     * @param {string} identifier
     * @returns number
     */
    compareIdentifierAttendee(identifier: string, spreadsheet: any): number {
        // try {
        const aux = this.translatedIdentifier;

        if (
            typeof spreadsheet === "undefined" ||
            spreadsheet === null ||
            spreadsheet.length <= 0
        )
            return -1;

        for (let column = 0; column < spreadsheet.length; column++) {
            let row = spreadsheet[column];

            if (
                typeof row[aux] !== "undefined" &&
                row[aux] !== null &&
                row[aux] === identifier
            )
                return column;
        }

        return -1;
    }

    allCustoms: Array<any> = [];
    checkCustomFieldImport(
        fieldNames: string[],
        element: any[],
        language: string,
        customFieldPosition: number
    ) {
        const isFirstImport = this.allCustoms.length === 0;
        const referenceList = isFirstImport ? this.listCustomField : this.allCustoms;

        let indexCustomAnswer = 0;

        for (let i = customFieldPosition; i < fieldNames.length; i++) {
            const fieldName = fieldNames[i];

            const index = this.findNextAvailableCustomField(
                referenceList,
                fieldName,
                language,
                this.allCustoms
            );

            if (index !== -1) {
                const baseField = referenceList[index];
                const custom = this.instantiateCustomField(baseField.uid, baseField);

                const answer = element[customFieldPosition + indexCustomAnswer];
                if (typeof answer !== "undefined") {
                    if (custom.type === "s" || custom.type === "select")
                    custom.value = answer;
                    else
                    custom.answer = answer;
                } else {
                    custom.value = null;
                    custom.answer = "";
                }

                if (isFirstImport) {
                    this.allCustoms.push(custom);
                } else {
                    this.allCustoms[index].answer = custom.answer;
                    this.allCustoms[index].value = custom.value;
                }
            } else {
                this.addCustomFieldError(fieldName);
            }

            indexCustomAnswer++;
        }

        const sourceList = isFirstImport ? this.listCustomField : this.allCustoms;
        for (let customField of sourceList) {
            const exists = this.verifyCustomFieldIndex(this.allCustoms, customField.uid);
            if (exists === -1) {
                this.allCustoms.push(
                    this.instantiateCustomField(customField.uid, {
                        ...customField,
                        value: null,
                        answer: ""
                    })
                );
            }
        }

        return this.allCustoms;
    }

    private findNextAvailableCustomField(
        referenceList: any[],
        fieldName: string,
        language: string,
        alreadyAdded: any[]
    ): number {
        for (let i = 0; i < referenceList.length; i++) {
            const candidate = referenceList[i];
            if (candidate.name[language] === fieldName) {
                const alreadyExists = alreadyAdded.some(
                    c => c.uid === candidate.uid
                );
                if (!alreadyExists) {
                    return i;
                }
            }
        }
        return -1;
    }


    private addCustomFieldError(fieldName: string) {
        const msg =
            this.translateService.instant("global.customfield_name_error_import") +
            fieldName;

        if (this.verifyCustomFieldErrorExist(msg) === -1) {
            this.messageErrors.push(msg);
        }
    }


    verifyCustomField(arrayCustom, nameCustom, language) {
        return arrayCustom.map(e => e.name[language]).indexOf(nameCustom);
    }

    verifyCustomFieldIndex(arrayCustom, customId) {
        if (arrayCustom !== null) {
            return arrayCustom
                .map(function (e) {
                    return e.uid;
                })
                .indexOf(customId);
        } else {
            return 1;
        }
    }

    verifyCustomFieldErrorExist(newError) {
        return this.messageErrors
            .map(function (e) {
                return e;
            })
            .indexOf(newError);
    }

    /** IGNORE EMPTY ROWS */
    ignoreRowEmpty(row: any) {
        if (row.length < 1 || this.checkRowEmpty(row)) {
            return false;
        }
        return true;
    }

    /**VERIFY IF ROW IS EMPTY */
    checkRowEmpty(row: any) {
        for (const cel of row) {
            if (typeof cel !== "undefined" && cel.length > 0) {
                return false;
            }
        }
        return true;
    }

    /* CHECK IF HAVE DOUBLE IDENTIFIERS */
    checkNumberRowIds(identifier: string, rowId: number) {
        let cont = 2;
        for (const attendee of this.newAttendees) {
            if (attendee.$identifier === identifier) {
                const column = this.checkLetterCols(this.identifier);
                this.messageErrors.push(
                    this.translateService.instant("global.equal_id") +
                        " " +
                        column +
                        cont +
                        " " +
                        this.translateService.instant("global.and") +
                        " " +
                        column +
                        rowId
                );
            }
            cont++;
        }
    }

    /* RETURN EXCEL COLUMN LETTER OF PARAMETER */
    checkLetterCols(column: number) {
        let letter = "";
        switch (column) {
            case this.identifier: {
                letter = "A";
                break;
            }
            case this.name: {
                letter = "B";
                break;
            }
            case this.email: {
                letter = "C";
                break;
            }

            case this.emailRecovery: {
                letter = "D";
                break;
            }

            case this.groups: {
                letter = "M";
                break;
            }
        }
        return letter;
    }

    //VERIFICA SE EXISTE REPETIÇÃO DE E-MAILS NO EXCEL*/
    checkNumberRowEmail(email: string, rowId: number) {
        let cont = 2;
        for (const attendee of this.newAttendees) {
            if (attendee.$email === email) {
                const column = this.checkLetterCols(this.email);
                this.messageErrors.push(
                    this.translateService.instant("global.equal_email") +
                        " " +
                        column +
                        cont +
                        " " +
                        this.translateService.instant("global.and") +
                        " " +
                        column +
                        rowId
                );
            }
            cont++;
        }
    }

    // CLEAR INPUT AFTER IMPORT DATA
    clearInputFile() {
        this.inputFile.nativeElement.value = "";
        this.nameFile = null;
    }

    clearMessages() {
        this.theError = false;
        this.theErrorApi = false;
        this.theErrorApiDb = false;
        this.messageErrors = [];
        this.successMsg = false;
        this.attendeeErrorsApi = [];
        this.theErrorCustom = false;
        this.theErrorGroup = false;
        this.theErrorDocument = false;
        this.theErrorEmailInAttendee = false;
        this.sheetValidFormat = false;
        this.invalidFormatSheetMsg = null;
    }

    downloadAttendeesWithErrors() {
        this.someAttendeesExcelDownload;
    }

    // EXPORTA O EXCEL COM OS ATTENDEES
    async exportAllAttendees() {
        $("#exportLoading").modal("show");
        $("#selectExportOption").modal("toggle");
        this.dataExportAttendees = [];
        this.dataExportAttendees_DeDE = [];
        this.dataExportAttendees_EnUS = [];
        this.dataExportAttendees_EsES = [];
        this.dataExportAttendees_FrFR = [];
        this.dataExportAttendees_PtBR = [];

        this.dataExportAttendees = [
            [
                "Identifier*",
                "Name*",
                "E-mail*",
                "Recovery e-mail",
                "Title",
                "Company",
                "Description",
                "Photo (URL)",
                "Site",
                "Facebook",
                "Twitter",
                "LinkedIn",
                "Instagram",
                "Groups",
                "Documents",
            ],
        ];

        this.dataExportAttendees_DeDE = [
            ["Identifier*", "Title", "Description"],
        ];
        this.dataExportAttendees_EnUS = [
            ["Identifier*", "Title", "Description"],
        ];
        this.dataExportAttendees_EsES = [
            ["Identifier*", "Title", "Description"],
        ];
        this.dataExportAttendees_FrFR = [
            ["Identifier*", "Title", "Description"],
        ];
        this.dataExportAttendees_PtBR = [
            ["Identifier*", "Title", "Description"],
        ];

        // ADD NAME OF CUSTOM FIELD AT TOP
        for (const custom of this.listCustomField) {
            if (custom["name"] !== undefined) {
                this.dataExportAttendees[0].push(
                    custom["name"][this.principalEventLang]
                );
            }
        }

        // GET DATA OF ALL PARTICIPANTS
        this.dbAttendee.exportAttendees(
            this.moduleId,
            this.typeOrder,
            async (attendeesArray) => {
                // let array = attendeesArray['result'];
                // let decompress = LZString.decompress(array);
                // attendeesArray['result'] = JSON.parse(decompress);
                // attendeesArray['result'] = JSON.parse(attendeesArray['result']);

                if (
                    attendeesArray["message"] == "success" &&
                    attendeesArray["result"].length > 0
                ) {
                    let cont = 0;
                    /* generate workbook and add the worksheet */
                    const wb: XLSX.WorkBook = XLSX.utils.book_new();
                    for (let i = 0; i < attendeesArray["result"].length; i++) {
                        let attendee = attendeesArray["result"][i];
                        let row: any;
                        // Sort groups here
                        row = await this.preparesAttendeesExport(attendee);
                        await this.dataExportAttendees.push(row);

                        let row_PtBR: any;
                        let row_EnUS: any;
                        let row_EsES: any;
                        let row_FrFR: any;
                        let row_DeDE: any;

                        if (this.languages.PtBR) {
                            if (i == 0) {
                                let customFieldArray =
                                    this.getCustomFieldNameSheetTitle(
                                        attendeesArray["result"],
                                        "PtBR"
                                    );
                                if (customFieldArray) {
                                    for (let custom of customFieldArray) {
                                        this.dataExportAttendees_PtBR[0].push(
                                            custom?.toString() || ""
                                        );
                                    }
                                }
                            }
                            row_PtBR =
                                await this.prepareAttendeesTraslatedExport(
                                    attendee,
                                    "PtBR"
                                );
                            await this.dataExportAttendees_PtBR.push(row_PtBR);
                        }

                        if (this.languages.EnUS) {
                            if (i == 0) {
                                let customFieldArray =
                                    this.getCustomFieldNameSheetTitle(
                                        attendeesArray["result"],
                                        "EnUS"
                                    );
                                if (customFieldArray) {
                                    for (let custom of customFieldArray) {
                                        this.dataExportAttendees_EnUS[0].push(
                                            custom?.toString() || ""
                                        );
                                    }
                                }
                            }
                            row_EnUS =
                                await this.prepareAttendeesTraslatedExport(
                                    attendee,
                                    "EnUS"
                                );
                            await this.dataExportAttendees_EnUS.push(row_EnUS);
                        }

                        if (this.languages.EsES) {
                            if (i == 0) {
                                let customFieldArray =
                                    this.getCustomFieldNameSheetTitle(
                                        attendeesArray["result"],
                                        "EsES"
                                    );
                                if (customFieldArray) {
                                    for (let custom of customFieldArray) {
                                        this.dataExportAttendees_EsES[0].push(
                                            custom?.toString() || ""
                                        );
                                    }
                                }
                            }
                            row_EsES =
                                await this.prepareAttendeesTraslatedExport(
                                    attendee,
                                    "EsES"
                                );
                            await this.dataExportAttendees_EsES.push(row_EsES);
                        }

                        if (this.languages.FrFR) {
                            if (i == 0) {
                                let customFieldArray =
                                    this.getCustomFieldNameSheetTitle(
                                        attendeesArray["result"],
                                        "FrFR"
                                    );
                                if (customFieldArray) {
                                    for (let custom of customFieldArray) {
                                        this.dataExportAttendees_FrFR[0].push(
                                            custom?.toString() || ""
                                        );
                                    }
                                }
                            }
                            row_FrFR =
                                await this.prepareAttendeesTraslatedExport(
                                    attendee,
                                    "FrFR"
                                );
                            await this.dataExportAttendees_FrFR.push(row_FrFR);
                        }

                        if (this.languages.DeDE) {
                            if (i == 0) {
                                let customFieldArray =
                                    this.getCustomFieldNameSheetTitle(
                                        attendeesArray["result"],
                                        "DeDE"
                                    );
                                if (customFieldArray) {
                                    for (let custom of customFieldArray) {
                                        this.dataExportAttendees_DeDE[0].push(
                                            custom?.toString() || ""
                                        );
                                    }
                                }
                            }
                            row_DeDE =
                                await this.prepareAttendeesTraslatedExport(
                                    attendee,
                                    "DeDE"
                                );
                            await this.dataExportAttendees_DeDE.push(row_DeDE);
                        }

                        if (cont == attendeesArray["result"].length - 1) {
                            const wscols: XLSX.ColInfo[] = this.returnColmns();

                            /* At 96 PPI, 1 pt = 1 px */
                            const wsrows: XLSX.RowInfo[] = [
                                { hpx: 30 }, // "pixels"
                            ];

                            /* generate worksheet */
                            const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(
                                this.dataExportAttendees
                            );

                            /* TEST: column props */
                            ws["!cols"] = wscols;

                            /* TEST: row props */
                            ws["!rows"] = wsrows;

                            /* generate workbook and add the worksheet */
                            const wb: XLSX.WorkBook = XLSX.utils.book_new();
                            XLSX.utils.book_append_sheet(
                                wb,
                                ws,
                                "Principal - " + this.event.language
                            );
                            if (
                                this.languages.PtBR &&
                                this.principalEventLang !== "PtBR"
                            ) {
                                /* generate worksheet */
                                const ws: XLSX.WorkSheet =
                                    XLSX.utils.aoa_to_sheet(
                                        this.dataExportAttendees_PtBR
                                    );
                                /* TEST: column props */
                                ws["!cols"] = wscols;
                                /* TEST: row props */
                                ws["!rows"] = wsrows;
                                XLSX.utils.book_append_sheet(wb, ws, "pt-BR");
                            }

                            if (
                                this.languages.EnUS &&
                                this.principalEventLang !== "EnUS"
                            ) {
                                /* generate worksheet */
                                const ws: XLSX.WorkSheet =
                                    XLSX.utils.aoa_to_sheet(
                                        this.dataExportAttendees_EnUS
                                    );
                                /* TEST: column props */
                                ws["!cols"] = wscols;
                                /* TEST: row props */
                                ws["!rows"] = wsrows;
                                XLSX.utils.book_append_sheet(wb, ws, "en-US");
                            }

                            if (
                                this.languages.EsES &&
                                this.principalEventLang !== "EsES"
                            ) {
                                /* generate worksheet */
                                const ws: XLSX.WorkSheet =
                                    XLSX.utils.aoa_to_sheet(
                                        this.dataExportAttendees_EsES
                                    );
                                /* TEST: column props */
                                ws["!cols"] = wscols;
                                /* TEST: row props */
                                ws["!rows"] = wsrows;
                                XLSX.utils.book_append_sheet(wb, ws, "es-ES");
                            }

                            if (
                                this.languages.FrFR &&
                                this.principalEventLang !== "FrFR"
                            ) {
                                /* generate worksheet */
                                const ws: XLSX.WorkSheet =
                                    XLSX.utils.aoa_to_sheet(
                                        this.dataExportAttendees_FrFR
                                    );
                                /* TEST: column props */
                                ws["!cols"] = wscols;
                                /* TEST: row props */
                                ws["!rows"] = wsrows;
                                XLSX.utils.book_append_sheet(wb, ws, "fr-FR");
                            }

                            if (
                                this.languages.DeDE &&
                                this.principalEventLang !== "DeDE"
                            ) {
                                /* generate worksheet */
                                const ws: XLSX.WorkSheet =
                                    XLSX.utils.aoa_to_sheet(
                                        this.dataExportAttendees_DeDE
                                    );
                                /* TEST: column props */
                                ws["!cols"] = wscols;
                                /* TEST: row props */
                                ws["!rows"] = wsrows;
                                XLSX.utils.book_append_sheet(wb, ws, "de-DE");
                            }

                            /* save to file */
                            const wbout: string = XLSX.write(wb, {
                                bookType: "xlsx",
                                type: "binary",
                            });
                            saveAs(
                                new Blob([this.s2ab(wbout)]),
                                "attendees.xlsx"
                            );
                            this.data = null;
                            $("#exportLoading").modal("toggle");
                        }
                        cont++;
                    }
                } else {
                    // deu erro
                    // $('#exportLoading').modal('toggle')
                    // this.notExport.fire();
                    let cont = 0;
                    for (let custom of this.listCustomField) {
                        this.dataExportAttendees_PtBR[0].push(
                            custom["name"]["PtBR"]
                        );
                        this.dataExportAttendees_EnUS[0].push(
                            custom["name"]["EnUS"]
                        );
                        this.dataExportAttendees_EsES[0].push(
                            custom["name"]["EsES"]
                        );
                        this.dataExportAttendees_FrFR[0].push(
                            custom["name"]["FrFR"]
                        );
                        this.dataExportAttendees_DeDE[0].push(
                            custom["name"]["DeDE"]
                        );
                        cont++;
                    }

                    if (cont == this.listCustomField.length) {
                        const wscols: XLSX.ColInfo[] = this.returnColmns();

                        /* At 96 PPI, 1 pt = 1 px */
                        const wsrows: XLSX.RowInfo[] = [
                            { hpx: 30 }, // "pixels"
                        ];

                        /* generate worksheet */
                        const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(
                            this.dataExportAttendees
                        );

                        /* TEST: column props */
                        ws["!cols"] = wscols;

                        /* TEST: row props */
                        ws["!rows"] = wsrows;

                        /* generate workbook and add the worksheet */
                        const wb: XLSX.WorkBook = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(
                            wb,
                            ws,
                            "Principal - " + this.event.language
                        );

                        if (
                            this.languages.PtBR &&
                            this.principalEventLang !== "PtBR"
                        ) {
                            /* generate worksheet */
                            const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(
                                this.dataExportAttendees_PtBR
                            );
                            /* TEST: column props */
                            ws["!cols"] = wscols;
                            /* TEST: row props */
                            ws["!rows"] = wsrows;
                            XLSX.utils.book_append_sheet(wb, ws, "pt-BR");
                        }

                        if (
                            this.languages.EnUS &&
                            this.principalEventLang !== "EnUS"
                        ) {
                            /* generate worksheet */
                            const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(
                                this.dataExportAttendees_EnUS
                            );
                            /* TEST: column props */
                            ws["!cols"] = wscols;
                            /* TEST: row props */
                            ws["!rows"] = wsrows;
                            XLSX.utils.book_append_sheet(wb, ws, "en-US");
                        }

                        if (
                            this.languages.EsES &&
                            this.principalEventLang !== "EsES"
                        ) {
                            /* generate worksheet */
                            const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(
                                this.dataExportAttendees_EsES
                            );
                            /* TEST: column props */
                            ws["!cols"] = wscols;
                            /* TEST: row props */
                            ws["!rows"] = wsrows;
                            XLSX.utils.book_append_sheet(wb, ws, "es-ES");
                        }

                        if (
                            this.languages.FrFR &&
                            this.principalEventLang !== "FrFR"
                        ) {
                            /* generate worksheet */
                            const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(
                                this.dataExportAttendees_FrFR
                            );
                            /* TEST: column props */
                            ws["!cols"] = wscols;
                            /* TEST: row props */
                            ws["!rows"] = wsrows;
                            XLSX.utils.book_append_sheet(wb, ws, "fr-FR");
                        }

                        if (
                            this.languages.DeDE &&
                            this.principalEventLang !== "DeDE"
                        ) {
                            /* generate worksheet */
                            const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(
                                this.dataExportAttendees_DeDE
                            );
                            /* TEST: column props */
                            ws["!cols"] = wscols;
                            /* TEST: row props */
                            ws["!rows"] = wsrows;
                            XLSX.utils.book_append_sheet(wb, ws, "de-DE");
                        }

                        /* save to file */
                        const wbout: string = XLSX.write(wb, {
                            bookType: "xlsx",
                            type: "binary",
                        });
                        saveAs(new Blob([this.s2ab(wbout)]), "attendees.xlsx");
                        this.data = null;
                        $("#exportLoading").modal("toggle");
                    }
                }
            }
        );
        $("#selectExportOption").modal("hide");
        $("#exportLoading").modal("hide");
    }

    // PREPARA UM REGISTRO DE ATTENDEE PARA EXPORTAÇÃO
    async preparesAttendeesExport(attendee) {
        const row = [];

        row.push(attendee.identifier);
        row.push(attendee.name);
        row.push(attendee.email);
        row.push(attendee.emailRecovery);
        row.push(attendee.title[this.principalEventLang]);
        row.push(attendee.company);
        if (
            attendee.description[this.principalEventLang] !== null &&
            attendee.description[this.principalEventLang] !== undefined &&
            attendee.description[this.principalEventLang] !== ""
        ) {
            row.push(attendee.description[this.principalEventLang]);
        } else {
            row.push("");
        }
        row.push(attendee.photoUrl);
        row.push(attendee.website);
        row.push(attendee.facebook);
        row.push(attendee.twitter);
        row.push(attendee.linkedin);
        row.push(attendee.instagram);
        row.push(this.preparedGroupExport(attendee.groups));
        row.push(this.preparedDocumentExport(attendee.documents));

        const cfAnswers = await this.SCustomFields.getUserCfsAnswers(this.eventId, attendee.uid, TypeUser.ATTENDEE);
        for (const cf of this.listCustomField) {
            const answerObj = cfAnswers?.find(a => a.uid === cf.uid);
            let rowValue = "";

            if (cf.type === 's') {
                const answerId = answerObj ? answerObj.answer : null;
                if (answerId && cf.answerOptions)
                    rowValue = cf.answerOptions[answerId] ? cf.answerOptions[answerId][this.principalEventLang].toString() : ''; 
            }
            else 
                rowValue = answerObj ? answerObj?.answer?.toString() : '';

            row.push(rowValue || '');
        }

        return row;
    }

    // AJUDA A GERAR O ARQUIVO EXECL
    private s2ab(s: string): ArrayBuffer {
        const buf: ArrayBuffer = new ArrayBuffer(s.length);
        const view: Uint8Array = new Uint8Array(buf);
        for (let i = 0; i !== s.length; ++i) {
            view[i] = s.charCodeAt(i) & 0xff;
        }
        return buf;
    }

    getCustomFieldNameSheetTitle(attendeesArray, language) {
        let customArray = [];
        if (attendeesArray[0] && attendeesArray[0]["customField"]) {
            for (let custom of attendeesArray[0]["customField"]) {
                customArray.push(custom["name"][language]);
            }

            if (customArray) {
                if (
                    customArray.length ===
                    attendeesArray[0]["customField"].length
                ) {
                    return customArray;
                }
            }
        }
    }

    returnColmns() {
        let array = [
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            { wpx: 100 }, // "pixels"
            // { hidden: false } // hide column
        ];
        return array;
    }

    // PREPARA UM REGISTRO DE DADOS SECUNDÁRIOS TRADUZIDOS PARA EXPORTAÇÃO
    prepareAttendeesTraslatedExport(attendee, lang) {
        const row: any[] = [];
        if (attendee) {
            row.push(attendee.identifier);
            row.push(attendee.title[lang]);
            if (
                attendee.description[lang] !== null &&
                attendee.description[lang] !== undefined
            )
                row.push(attendee.description[lang]);
            else
                row.push("");

            if (attendee.customField)
                for (const custom of attendee.customField) {
                    if (custom.type == "text")
                        row.push(custom.answer);
                    else
                        row.push(custom.value);
                }
        }
        return row;
    }

    preparedGroupExport(list: any) {
        let myDatas = "";
        if (list !== null && list !== undefined) {
            let groups = [];

            for (const uid in list) {
                groups.push(list[uid]);
            }

            for (
                let i = 0;
                i <
                groups.sort((a, b) =>
                    a.name < b.name ? -1 : a.name > b.name ? 1 : 0
                ).length;
                i++
            ) {
                i < groups.length - 1
                    ? (myDatas += groups[i].name + ";")
                    : (myDatas += groups[i].name);
            }
        }
        return myDatas;
    }

    preparedDocumentExport(list: any) {
        let myDatas = "";
        let i = 1;
        if (list !== null && list !== undefined) {
            let array = Object.values(list)
            for (const data of array) {
                if (i < array.length) {
                    myDatas += data['identifier'] + ";";
                } else {
                    myDatas += data['identifier'];
                }
                i++;
            }

            if (list.length <= 0) {
                myDatas = null;
            }
        }
        return myDatas;
    }

    async downloadAttendeesImportError() {
        this.dataExportAttendees = [];
        this.dataExportAttendees_DeDE = [];
        this.dataExportAttendees_EnUS = [];
        this.dataExportAttendees_EsES = [];
        this.dataExportAttendees_FrFR = [];
        this.dataExportAttendees_PtBR = [];
        this.dataExportAttendees = [
            [
                "Identifier*",
                "Name*",
                "E-mail*",
                "Recovery e-mail",
                "Title",
                "Company",
                "Description",
                "Photo (URL)",
                "Site",
                "Facebook",
                "Twitter",
                "LinkedIn",
                "Instagram",
                "Groups",
                "Documents",
            ],
        ];

        this.dataExportAttendees_DeDE = [
            ["Identifier*", "Title", "Description"],
        ];
        this.dataExportAttendees_EnUS = [
            ["Identifier*", "Title", "Description"],
        ];
        this.dataExportAttendees_EsES = [
            ["Identifier*", "Title", "Description"],
        ];
        this.dataExportAttendees_FrFR = [
            ["Identifier*", "Title", "Description"],
        ];
        this.dataExportAttendees_PtBR = [
            ["Identifier*", "Title", "Description"],
        ];

        // PEGA OS DADOS DE CADA PARTICIPANTE
        let cont = 0;

        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();

        for (let i = 0; i < this.attendeeErrorsApi.length; i++) {
            let attendee = this.attendeeErrorsApi[i];
            let row: any;
            row = await this.preparesAttendeesExport(attendee);
            await this.dataExportAttendees.push(row);
            let row_PtBR: any;
            let row_EnUS: any;
            let row_EsES: any;
            let row_FrFR: any;
            let row_DeDE: any;
            if (this.languages.PtBR) {
                if (i == 0) {
                    let customFieldArray = this.getCustomFieldNameSheetTitle(
                        this.attendeeErrorsApi,
                        "PtBR"
                    );
                    for (let custom of customFieldArray) {
                        this.dataExportAttendees_PtBR[0].push(custom);
                    }
                }
                row_PtBR = await this.prepareAttendeesTraslatedExport(
                    attendee,
                    "PtBR"
                );
                await this.dataExportAttendees_PtBR.push(row_PtBR);
            }

            if (this.languages.EnUS) {
                if (i == 0) {
                    let customFieldArray = this.getCustomFieldNameSheetTitle(
                        this.attendeeErrorsApi,
                        "EnUS"
                    );
                    for (let custom of customFieldArray) {
                        this.dataExportAttendees_EnUS[0].push(custom);
                    }
                }
                row_EnUS = await this.prepareAttendeesTraslatedExport(
                    attendee,
                    "EnUS"
                );
                await this.dataExportAttendees_EnUS.push(row_EnUS);
            }

            if (this.languages.EsES) {
                if (i == 0) {
                    let customFieldArray = this.getCustomFieldNameSheetTitle(
                        this.attendeeErrorsApi,
                        "EsES"
                    );
                    for (let custom of customFieldArray) {
                        this.dataExportAttendees_EsES[0].push(custom);
                    }
                }
                row_EsES = await this.prepareAttendeesTraslatedExport(
                    attendee,
                    "EsES"
                );
                await this.dataExportAttendees_EsES.push(row_EsES);
            }

            if (this.languages.FrFR) {
                if (i == 0) {
                    let customFieldArray = this.getCustomFieldNameSheetTitle(
                        this.attendeeErrorsApi,
                        "FrFR"
                    );
                    if (customFieldArray) {
                        for (let custom of customFieldArray) {
                            this.dataExportAttendees_FrFR[0].push(custom);
                        }
                    }
                }
                row_FrFR = await this.prepareAttendeesTraslatedExport(
                    attendee,
                    "FrFR"
                );
                await this.dataExportAttendees_FrFR.push(row_FrFR);
            }

            if (this.languages.DeDE) {
                if (i == 0) {
                    let customFieldArray = this.getCustomFieldNameSheetTitle(
                        this.attendeeErrorsApi,
                        "DeDE"
                    );
                    for (let custom of customFieldArray) {
                        this.dataExportAttendees_DeDE[0].push(custom);
                    }
                }
                row_DeDE = await this.prepareAttendeesTraslatedExport(
                    attendee,
                    "DeDE"
                );
                await this.dataExportAttendees_DeDE.push(row_DeDE);
            }
            if (cont == this.attendeeErrorsApi.length - 1) {
                const wscols: XLSX.ColInfo[] = this.returnColmns();

                /* At 96 PPI, 1 pt = 1 px */
                const wsrows: XLSX.RowInfo[] = [
                    { hpx: 30 }, // "pixels"
                ];

                /* generate worksheet */
                const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(
                    this.dataExportAttendees
                );
                /* TEST: column props */
                ws["!cols"] = wscols;
                /* TEST: row props */
                ws["!rows"] = wsrows;
                XLSX.utils.book_append_sheet(
                    wb,
                    ws,
                    "Principal - " + this.event.language
                );

                // ADDITIONAL DATA TRANSLATED
                if (this.languages.PtBR && this.principalEventLang !== "PtBR") {
                    /* generate worksheet */
                    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(
                        this.dataExportAttendees_PtBR
                    );
                    /* TEST: column props */
                    ws["!cols"] = wscols;
                    /* TEST: row props */
                    ws["!rows"] = wsrows;
                    XLSX.utils.book_append_sheet(wb, ws, "pt-BR");
                }

                if (this.languages.EnUS && this.principalEventLang !== "EnUS") {
                    /* generate worksheet */
                    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(
                        this.dataExportAttendees_EnUS
                    );
                    /* TEST: column props */
                    ws["!cols"] = wscols;
                    /* TEST: row props */
                    ws["!rows"] = wsrows;
                    XLSX.utils.book_append_sheet(wb, ws, "en-US");
                }

                if (this.languages.EsES && this.principalEventLang !== "EsES") {
                    /* generate worksheet */
                    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(
                        this.dataExportAttendees_EsES
                    );
                    /* TEST: column props */
                    ws["!cols"] = wscols;
                    /* TEST: row props */
                    ws["!rows"] = wsrows;
                    XLSX.utils.book_append_sheet(wb, ws, "es-ES");
                }

                if (this.languages.FrFR && this.principalEventLang !== "FrFR") {
                    /* generate worksheet */
                    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(
                        this.dataExportAttendees_FrFR
                    );
                    /* TEST: column props */
                    ws["!cols"] = wscols;
                    /* TEST: row props */
                    ws["!rows"] = wsrows;
                    XLSX.utils.book_append_sheet(wb, ws, "fr-FR");
                }

                if (this.languages.DeDE && this.principalEventLang !== "DeDE") {
                    /* generate worksheet */
                    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(
                        this.dataExportAttendees_DeDE
                    );
                    /* TEST: column props */
                    ws["!cols"] = wscols;
                    /* TEST: row props */
                    ws["!rows"] = wsrows;
                    XLSX.utils.book_append_sheet(wb, ws, "de-DE");
                }

                /* save to file */
                const wbout: string = XLSX.write(wb, {
                    bookType: "xlsx",
                    type: "binary",
                });
                saveAs(new Blob([this.s2ab(wbout)]), "import_error.xlsx");
                this.data = null;
            }
            cont++;
        }
    }

    exportTemplate() {
        this.dataExportAttendees = [];
        this.dataExportAttendees_DeDE = [];
        this.dataExportAttendees_EnUS = [];
        this.dataExportAttendees_EsES = [];
        this.dataExportAttendees_FrFR = [];
        this.dataExportAttendees_PtBR = [];
        this.dataExportAttendees = [
            [
                "Identifier*",
                "Name*",
                "E-mail*",
                "Recovery e-mail",
                "Title",
                "Company",
                "Description",
                "Photo (URL)",
                "Site",
                "Facebook",
                "Twitter",
                "LinkedIn",
                "Instagram",
                "Groups",
                "Documents",
            ],
        ];

        this.dataExportAttendees_DeDE = [
            ["Identifier*", "Title", "Description"],
        ];
        this.dataExportAttendees_EnUS = [
            ["Identifier*", "Title", "Description"],
        ];
        this.dataExportAttendees_EsES = [
            ["Identifier*", "Title", "Description"],
        ];
        this.dataExportAttendees_FrFR = [
            ["Identifier*", "Title", "Description"],
        ];
        this.dataExportAttendees_PtBR = [
            ["Identifier*", "Title", "Description"],
        ];

        for (let custom of this.listCustomField) {
            this.dataExportAttendees[0].push(
                custom.name[this.principalEventLang]
            );
            this.dataExportAttendees_PtBR[0].push(custom.name.PtBR);
            this.dataExportAttendees_EnUS[0].push(custom.name.EnUS);
            this.dataExportAttendees_EsES[0].push(custom.name.EsES);
            this.dataExportAttendees_FrFR[0].push(custom.name.FrFR);
            this.dataExportAttendees_DeDE[0].push(custom.name.DeDE);
        }

        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();

        const wscols: XLSX.ColInfo[] = this.returnColmns();

        /* At 96 PPI, 1 pt = 1 px */
        const wsrows: XLSX.RowInfo[] = [
            { hpx: 30 }, // "pixels"
        ];

        /* generate worksheet */
        const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(
            this.dataExportAttendees
        );
        /* TEST: column props */
        ws["!cols"] = wscols;
        /* TEST: row props */
        ws["!rows"] = wsrows;
        XLSX.utils.book_append_sheet(
            wb,
            ws,
            "Principal - " + this.event.language
        );

        // ADDITIONAL DATA TRANSLATED
        if (this.languages.PtBR && this.principalEventLang !== "PtBR") {
            /* generate worksheet */
            const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(
                this.dataExportAttendees_PtBR
            );
            /* TEST: column props */
            ws["!cols"] = wscols;
            /* TEST: row props */
            ws["!rows"] = wsrows;
            XLSX.utils.book_append_sheet(wb, ws, "pt-BR");
        }

        if (this.languages.EnUS && this.principalEventLang !== "EnUS") {
            /* generate worksheet */
            const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(
                this.dataExportAttendees_EnUS
            );
            /* TEST: column props */
            ws["!cols"] = wscols;
            /* TEST: row props */
            ws["!rows"] = wsrows;
            XLSX.utils.book_append_sheet(wb, ws, "en-US");
        }

        if (this.languages.EsES && this.principalEventLang !== "EsES") {
            /* generate worksheet */
            const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(
                this.dataExportAttendees_EsES
            );
            /* TEST: column props */
            ws["!cols"] = wscols;
            /* TEST: row props */
            ws["!rows"] = wsrows;
            XLSX.utils.book_append_sheet(wb, ws, "es-ES");
        }

        if (this.languages.FrFR && this.principalEventLang !== "FrFR") {
            /* generate worksheet */
            const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(
                this.dataExportAttendees_FrFR
            );
            /* TEST: column props */
            ws["!cols"] = wscols;
            /* TEST: row props */
            ws["!rows"] = wsrows;
            XLSX.utils.book_append_sheet(wb, ws, "fr-FR");
        }

        if (this.languages.DeDE && this.principalEventLang !== "DeDE") {
            /* generate worksheet */
            const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(
                this.dataExportAttendees_DeDE
            );
            /* TEST: column props */
            ws["!cols"] = wscols;
            /* TEST: row props */
            ws["!rows"] = wsrows;
            XLSX.utils.book_append_sheet(wb, ws, "de-DE");
        }
        /* save to file */
        const wbout: string = XLSX.write(wb, {
            bookType: "xlsx",
            type: "binary",
        });
        saveAs(new Blob([this.s2ab(wbout)]), "template_attendees.xlsx");
        this.data = null;
    }

    instantiateCustomField(uid: string, data: any) {
        const custom = new eventCustomField(
            data.name,
            data.type,
            data.exibicao,
            data.edicao
        );
        if (uid)
            custom.uid = uid;

        return custom;
    }

    requiredEditProfile($ev) {
        this.dbEvent.changeRequiredProfileEdit(this.eventId, $ev);
    }

    /**
     * Allow or block chat use between participants
     * @param $ev
     */
    allowChatUseChange($ev) {
        this.allowChatUse = $ev;
        this.dbAttendee.changeChatUse(
            this.eventId,
            this.moduleId,
            this.allowChatUse
        );
    }

    /**
     * Allow or block filter on list attendees
     * @param $ev
     */
    allowFilterChanged($ev, type: string) {
        /* ----litle code to format name of custom fields
         to be set to firestore database ---- */
        let typeArray = type.split(" ");
        let formatType = "";
        let i = 0;
        for (let ch of typeArray) {
            i++;
            formatType = formatType.concat(ch);
            if (i !== typeArray.length) {
                formatType = formatType.concat("_");
            }
        }
        /* ------------------------------------- */
        let value = null;
        if (type === "company") {
            value = this.allowFilterCompany = $ev;
            this.disableFilterComVisibility = true;
        } else if (type === "post") {
            value = this.allowFilterPost = $ev;
            this.disableFilterPostVisibility = true;
        } else if (type === "customs") {
            value = this.allowFilterCustomFields = $ev;
            this.disableCustomFieldsFilterVisibility = true;
        } else {
            for (let i = 0; i < this.customNameArray.length; i++) {
                if (
                    type ===
                    "allowFilterCustomField_" + this.customNameArray[i]
                ) {
                    value = this.allowFilterCustomsFieldsArray[i] = $ev;
                    this.disableCustomFieldsFilterArrayVisibility[i] = true;
                }
            }
        }
        this.dbAttendee.changeFilterVisibility(
            this.moduleId,
            value,
            formatType,
            (result) => {
                if (!result.value) {
                    this.allowFilterCompany =
                        result.type === "company" && !this.allowFilterCompany;
                    this.allowFilterPost =
                        result.type === "post" && !this.allowFilterPost;
                    this.allowFilterCustomFields =
                        result.type === "customs" &&
                        !this.allowFilterCustomFields;
                    for (let i = 0; i < this.customNameArray.lentgth; i++) {
                        this.allowFilterCustomsFieldsArray[i] =
                            result.type === this.customNameArray[i] &&
                            !this.allowFilterCustomsFieldsArray[i];
                    }
                }
                this.disableFilterComVisibility = false;
                this.disableFilterPostVisibility = false;
                this.disableCustomFieldsFilterVisibility = false;

                // disable generic custom fields
                for (let i = 0; i < this.customNameArray.length; i++) {
                    this.disableCustomFieldsFilterArrayVisibility[i] = false;
                }
            }
        );
    }

    /**
     * Allow or block visio use between participants
     * @param $ev
     */
    // allowVisioUseChange($ev) {
    //     this.allowVisioUse = $ev;
    //     this.dbAttendee.changeVisioUse(this.eventId, this.moduleId, this.allowVisioUse);
    // }

    setDefaultAttendeeModule($ev) {
        this.defaultModulePublicAttendees = $ev;
        if ($ev == true)
            this.dbEvent.updateField(
                this.eventId,
                { default_attendee_module: this.moduleId }
            );
        else if ($ev == false)
            this.dbEvent.updateField(
                this.eventId,
                { default_attendee_module: "" }
            );
    }

    changeFirstAccessLanguage() {
        this.dbAttendee.takeChangesInModule(this.moduleId, this.eventId, {
            firstAccessCodeLanguage: this.first_access_language,
        });
    }

    userResetReference: Attendee = null;
    resetUserAccountProblem() {
        $("#exportLoading").modal("show");
        this.dbAttendee
            .resetAccount(this.userResetReference)
            .then((response) => {
                if (response == 0) {
                    this.userResetReference = null;
                    setTimeout(() => {
                        $("#exportLoading").modal("toggle");
                        this.successSwal.fire();
                    }, 200);
                } else if (response == 1) {
                    this.userResetReference = null;
                    this.notReconfiguredSwal.fire();
                    setTimeout(() => {
                        $("#exportLoading").modal("toggle");
                    }, 150);
                }
            })
            .catch((error) => {
                this.userResetReference = null;
                this.errorSwal.fire();
                setTimeout(() => {
                    $("#exportLoading").modal("toggle");
                }, 150);
            });
    }

    printQrCodes(includeTitle: boolean, includeCompany: boolean) {
        $("#exportLoading").modal("show");
        let size = this.listAttendees.length;
        let array = [];
        for (let i = 0; i < size; i++) {
            // get element canvas and make data url string
            let elem = document.getElementById(`qrcodesAll${i}`);
            const canvas = elem.childNodes[0]
                .childNodes[0] as HTMLCanvasElement;
            const imageData = canvas.toDataURL("image/png").toString();
            // size and position of qrcodes
            let imgWidth = 150;
            let imgHeight = (canvas.height * imgWidth) / canvas.width;
            const attendee = this.listAttendees[i];
            const qrObj: any = {
                name: attendee.$name.trim(),
                image: imageData,
                width: imgWidth,
                height: imgHeight,
                position: 30
            };

            if (includeTitle) {
                qrObj.tittle = (attendee.$title as any)[this.eventLanguage]?.trim();
            }
            if (includeCompany) {
                qrObj.company = attendee.$company?.trim();
            }
            array.push(qrObj);

            if (array.length == size) {
                this.saveAllQrCodes(array);
            }
        }
    }

    saveAllQrCodes(qrcodes) {
        let size = qrcodes.length;
        // start jspdf a4 format in portrait mode using milimiters
        let pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF

        let pageHeight =
            pdf.internal.pageSize.height || pdf.internal.pageSize.getHeight();
        let pageWidth =
            pdf.internal.pageSize.width || pdf.internal.pageSize.getWidth();
        for (let i = 0; i < size; i++) {
            // add qrcode image at the very top of the page
            const qrX = (pageWidth - qrcodes[i].width) / 2;
            const qrY = 10;
            pdf.addImage(
                qrcodes[i].image,
                "PNG",
                qrX,
                qrY,
                qrcodes[i].width,
                qrcodes[i].height
            );

            // Helper function to split text into lines that fit within width
            const splitTextToLines = (text: string, maxWidth: number, fontSize: number) => {
                pdf.setFontSize(fontSize);
                const words = text.split(' ');
                const lines = [];
                let currentLine = words[0] || '';

                for (let i = 1; i < words.length; i++) {
                    const testLine = currentLine + ' ' + words[i];
                    const testWidth = pdf.getTextWidth(testLine);

                    if (testWidth > maxWidth) {
                        lines.push(currentLine);
                        currentLine = words[i];
                    } else {
                        currentLine = testLine;
                    }
                }
                lines.push(currentLine);
                return lines;
            };

            // add name
            let textY = qrY + qrcodes[i].height + 25;
            pdf.setFontType("bold");
            pdf.setFontSize(40);

            const maxTextWidth = pageWidth * 0.70;
            const nameLines = splitTextToLines(qrcodes[i].name, maxTextWidth, 50);

            nameLines.forEach((line, index) => {
                const currentY = textY + (index * 16);
                pdf.text(
                    line,
                    pageWidth / 2,
                    currentY,
                    { align: "center" }
                );
            });
            textY += nameLines.length > 1 ? (nameLines.length - 1) * 16 : 0;

            //add company if present
            if (qrcodes[i].company) {
                textY += 20;
                pdf.setFontType("bold");
                pdf.setFontSize(30);

                const companyLines = splitTextToLines(qrcodes[i].company, maxTextWidth, 40);

                companyLines.forEach((line, index) => {
                    const currentY = textY + (index * 14);
                    pdf.text(
                        line,
                        pageWidth / 2,
                        currentY,
                        { align: "center" }
                    );
                });
                textY += companyLines.length > 1 ? (companyLines.length - 1) * 14 : 0;
            }

            // add title if present
            if (qrcodes[i].tittle) {
                textY += 18;
                pdf.setFontType("normal");
                pdf.setFontSize(20);

                const titleLines = splitTextToLines(qrcodes[i].tittle, maxTextWidth, 40);

                titleLines.forEach((line, index) => {
                    const currentY = textY + (index * 14);
                    pdf.text(
                        line,
                        pageWidth / 2,
                        currentY,
                        { align: "center" }
                    );
                });
            }

            // generate new page
            if (i < size - 1) {
                pdf.addPage();
            }
            if (i == size - 1) {
                pdf.save("attendees-qrcodes.pdf"); // Generated PD
                setTimeout(() => {
                    $("#exportLoading").modal("toggle");
                }, 1000);
            }
        }
    }

    convertLangFormat(lang) {
        let formatedLang;
        switch (lang) {
            case "pt_BR": {
                formatedLang = "PtBR";
                break;
            }
            case "en_US": {
                formatedLang = "EnUS";
                break;
            }
            case "es_ES": {
                formatedLang = "EsES";
                break;
            }
            case "fr_FR": {
                formatedLang = "FrFR";
                break;
            }
            case "de_DE": {
                formatedLang = "DeDE";
                break;
            }
        }
        return formatedLang;
    }

    propertyChanged($ev, property: string) {
        let value = null;
        if (property === "showLetters") {
            value = this.showLetters = $ev;
            this.disableLettreVisibility = true;
        } else if (property === "emailVisibilty") {
            value = this.emailVisibilty = $ev;
        } else if (property === "showBtnVisio") {
            value = this.btnVisioVisibilty = $ev;
        } else if (property === "showOnlyLoggedUsers") {
            value = this.showOnlyLoggedUsersVisibilty = $ev;
        }
        this.disableLettreVisibility = true;

        this.dbAttendee.editPropVisibility(
            this.moduleId,
            property,
            value,
            (result) => {
                if (!result && property == "showLetters") {
                    this.showLetters = !this.showLetters;
                } else if (!result && property == "emailVisibilty") {
                    this.emailVisibilty = !this.emailVisibilty;
                } else if (!result && property == "showBtnVisio") {
                    this.btnVisioVisibilty = !this.btnVisioVisibilty;
                } else if (!result && property === "showOnlyLoggedUsers") {
                    this.showOnlyLoggedUsersVisibilty =
                        !this.showOnlyLoggedUsersVisibilty;
                }
                this.disableLettreVisibility = false;
            }
        );
    }

    setTexts(type: string){
        if(type === 'company'){
            this.companyFilterText = this.companyFilterText.trim()
            this.disabledCompanyFilterText = true
            this.dbAttendee.editPropVisibility(
                this.moduleId,
                'companyFilterText',
                this.companyFilterText,
                (result) => {
                    this.disabledCompanyFilterText = false
                })
        } else if(type === 'post'){
            this.postFilterText = this.postFilterText.trim()
            this.disabledPostFilterText = true
            this.dbAttendee.editPropVisibility(
                this.moduleId,
                'postFilterText',
                this.postFilterText,
                (result) => {
                    this.disabledPostFilterText = false
                })
        }
    }
}
